import { MOMENT_TIME } from '../../momenttime'
import * as chaodai from "../../data/base/chaodai";
import { UTILS } from '../../utils';

var PAIPAN = {
    /**
     * 是否区分 早晚子 时,true则23:00-24:00算成上一天
     * 我们是按24点为分割线的
     * Todo:暂时没有做这块的逻辑
     * //data.zwzs 0传true23, 1默认false24不用传
     * @var bool
     */
    zwz: false,
    /**
     * 十天干
     * @var array
     */
    ctg: new Array('甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'),

    /**
     * 五行
     */
    cwx: new Array('金', '木', '水', '火', '土'), //char of WuXing
    /**
     * 天干对应五行
     * @var array
     */
    tgwx: new Array(1, 1, 3, 3, 4, 4, 0, 0, 2, 2),
    /**
     * 十二地支
     * @var array
     */
    //02469
    cdz: new Array('子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'), //char of DiZhi
    /**
     * 地支对应五行
     * @var array
     */
    dzwx: new Array(2, 4, 1, 1, 4, 3, 3, 4, 0, 0, 4, 2),
    /**
     * 地支藏干
     * @var array
     */
    dzcg: new Array([9], [5, 9, 7], [0, 2, 4], [1], [4, 1, 9], [2, 4, 6], [3, 5], [5, 3, 1], [6, 8, 4], [7], [4, 7, 3], [8, 0]),
    /**
     * 十二生肖
     * @var array
     */
    csa: new Array('鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'), //char of symbolic animals
    /**
     * 十二星座
     * @var array
     */
    cxz: new Array('水瓶座', '双鱼座', '白羊座', '金牛座', '双子座', '巨蟹座', '狮子座', '处女座', '天秤座', '天蝎座', '射手座', '摩羯座'), //char of XingZuo
    /**
     * 星期
     * @var array
     */
    wkd: new Array('日', '一', '二', '三', '四', '五', '六'), //week day
    /**
     * 廿四节气(从春分开始)
     * @var array
     */
    jq: new Array('春分', '清明', '谷雨', '立夏', '小满', '芒种', '夏至', '小暑', '大暑', '立秋', '处暑', '白露', '秋分', '寒露', '霜降', '立冬', '小雪', '大雪', '冬至', '小寒', '大寒', '立春', '雨水', '惊蛰'), //JieQi

    jqall: new Array('立春', '雨水', '惊蛰','春分', '清明', '谷雨', '立夏', '小满', '芒种', '夏至', '小暑', '大暑', '立秋', '处暑', '白露', '秋分', '寒露', '霜降', '立冬', '小雪', '大雪', '冬至', '小寒', '大寒'), //JieQi
    /**
     * 均值朔望月長(mean length of synodic month)
     * @var float
     */
    synmonth: 29.530588853,

    /**
     *
     * @param {*} yy
     */
    VE: function (yy) {

    },

    /**
     *
     * @param {*} yy
     * @param {*} mm
     */
    DeltaT: function (yy, mm) {
        var u, t, dt, y;
        y = yy + (mm - 0.5) / 12;

        if (y <= -500) {
            u = (y - 1820) / 100;
            dt = (-20 + 32 * u * u);
        } else {
            if (y < 500) {
                u = y / 100;
                dt = (10583.6 - 1014.41 * u + 33.78311 * u * u - 5.952053 * u * u * u - 0.1798452 * u * u * u * u + 0.022174192 * u * u * u * u * u + 0.0090316521 * u * u * u * u * u * u);
            } else {
                if (y < 1600) {
                    u = (y - 1000) / 100;
                    dt = (1574.2 - 556.01 * u + 71.23472 * u * u + 0.319781 * u * u * u - 0.8503463 * u * u * u * u - 0.005050998 * u * u * u * u * u + 0.0083572073 * u * u * u * u * u * u);
                } else {
                    if (y < 1700) {
                        t = y - 1600;
                        dt = (120 - 0.9808 * t - 0.01532 * t * t + t * t * t / 7129);
                    } else {
                        if (y < 1800) {
                            t = y - 1700;
                            dt = (8.83 + 0.1603 * t - 0.0059285 * t * t + 0.00013336 * t * t * t - t * t * t * t / 1174000);
                        } else {
                            if (y < 1860) {
                                t = y - 1800;
                                dt = (13.72 - 0.332447 * t + 0.0068612 * t * t + 0.0041116 * t * t * t - 0.00037436 * t * t * t * t + 0.0000121272 * t * t * t * t * t - 0.0000001699 * t * t * t * t * t * t + 0.000000000875 * t * t * t * t * t * t * t);
                            } else {
                                if (y < 1900) {
                                    t = y - 1860;
                                    dt = (7.62 + 0.5737 * t - 0.251754 * t * t + 0.01680668 * t * t * t - 0.0004473624 * t * t * t * t + t * t * t * t * t / 233174);
                                } else {
                                    if (y < 1920) {
                                        t = y - 1900;
                                        dt = (-2.79 + 1.494119 * t - 0.0598939 * t * t + 0.0061966 * t * t * t - 0.000197 * t * t * t * t);
                                    } else {
                                        if (y < 1941) {
                                            t = y - 1920;
                                            dt = (21.2 + 0.84493 * t - 0.0761 * t * t + 0.0020936 * t * t * t);
                                        } else {
                                            if (y < 1961) {
                                                t = y - 1950;
                                                dt = (29.07 + 0.407 * t - t * t / 233 + t * t * t / 2547);
                                            } else {
                                                if (y < 1986) {
                                                    t = y - 1975;
                                                    dt = (45.45 + 1.067 * t - t * t / 260 - t * t * t / 718);
                                                } else {
                                                    if (y < 2005) {
                                                        t = y - 2000;
                                                        dt = (63.86 + 0.3345 * t - 0.060374 * t * t + 0.0017275 * t * t * t + 0.000651814 * t * t * t * t + 0.00002373599 * t * t * t * t * t);
                                                    } else {
                                                        if (y < 2050) {
                                                            t = y - 2000;
                                                            dt = (62.92 + 0.32217 * t + 0.005589 * t * t);
                                                        } else {
                                                            if (y < 2150) {
                                                                u = (y - 1820) / 100;
                                                                dt = (-20 + 32 * u * u - 0.5628 * (2150 - y));
                                                            } else {
                                                                u = (y - 1820) / 100;
                                                                dt = (-20 + 32 * u * u);
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        if (y < 1955 || y >= 2005) dt = dt - (0.000012932 * (y - 1955) * (y - 1955));
        var DeltaT = dt / 60;    //將秒轉換為分
        return DeltaT;
    },

    /**
     * 获取指定年的春分开始的24节气,另外多取2个确保覆盖完一个公历年
     * 大致原理是:先用此方法得到理论值,再用摄动值(Perturbation)和固定参数DeltaT做调整
     * @param int $yy
     * @return boolean
     */
    MeanJQJD: function ($yy) {

        var $all = this.getJieQi($yy, 26);
        return $all;

    },

    getJieQi: function ($yy, $num = 26) {
        return this.getJieQi($yy, $num);
    },

    getFirstJq: function($y) {
        var $jq = [];
        var $i;

        $y  =$y-1;
        var $t1 = 365.2422 * ($y - 2000); // 农历年首始于前一年的冬至,为了节气中气一起算,取前年大雪之前
        $i=21;
        // 计算节气(从冬至开始),注意:返回的是力学时
        $jq[$i] = this.jiaoCal($t1 + $i * 15.22, $i * 15, 0); // 顺便计算节气,它不是农历定朔计算所必需的
        $jq[$i] = $jq[$i] + this.J2000 + 8 / 24; // 计算第i个节气(i=0是春分),结果转为北京时

        return $jq[$i]
    },

    /**
     * 获取指定年的春分开始作Perturbaton調整後的24节气,可以多取2个
     * @param int $yy
     * @param int $start 0-25
     * @param int $end 0-25
     * @return array
     */
    GetAdjustedJQ: function ($yy, $start, $end) {
        if ($start < 0 || $start > 25) {
            return [];
        }
        if ($end < 0 || $end > 25) {
            return [];
        }

        var $jq = [];

        var $jqjd = this.MeanJQJD($yy); //获取该年春分开始的24节气时间点
        var $k;


        for ($k = 0; $k < $jqjd.length; $k++) {

            if ($k < $start) {
                continue;
            }
            if ($k > $end) {
                continue;
            }
            $jq[$k] = $jqjd[$k];
        }
        return $jq;
    },
    /**
     * 求出以某年立春點開始的節(注意:为了方便计算起运数,此处第0位为上一年的小寒)
     * @param int $yy
     * @return array jq[(2*$k+21)%24]
     */
    GetPureJQsinceSpring: function ($yy) {
        var $jdpjq = [];

        var $dj = this.GetAdjustedJQ($yy - 1, 19, 23); //求出含指定年立春開始之3個節氣JD值,以前一年的年值代入
        var $k


        for ($k = 0; $k < $dj.length; $k++) {
            if ($k < 19) {
                continue;
            }
            if ($k > 23) {
                continue;
            }
            if ($k % 2 == 0) {
                continue;
            }
            $jdpjq[$jdpjq.length] = $dj[$k]; //19小寒;20大寒;21立春;22雨水;23惊蛰
        }


        $dj = this.GetAdjustedJQ($yy, 0, 25); //求出指定年節氣之JD值,從春分開始,到大寒,多取两个确保覆盖一个公历年,也方便计算起运数


        for (var $zz = 0; $zz < $dj.length; $zz++) {

            if ($zz % 2 == 0) {
                continue;
            }
            $jdpjq[$jdpjq.length] = $dj[$zz];

        }

        return $jdpjq;
    },
    /**
     * 求出自冬至點為起點的連續15個中氣
     * @param int $yy
     * @return array jq[(2*$k+18)%24]
     */
    GetZQsinceWinterSolstice: function ($yy) {
        var $jdzq = [];
        var $dj, $k;

        $dj = this.GetAdjustedJQ($yy - 1, 18, 23); //求出指定年冬至開始之節氣JD值,以前一年的值代入
        $jdzq[0] = $dj[18]; //冬至
        $jdzq[1] = $dj[20]; //大寒
        $jdzq[2] = $dj[22]; //雨水

        $dj = this.GetAdjustedJQ($yy, 0, 23); //求出指定年節氣之JD值
        for ($k = 0; $k < $dj.length; $k++) {

            if ($k % 2 != 0) {
                continue;
            }
            $jdzq[$jdzq.length] = $dj[$k];
        }
        return $jdzq;
    },

    /**
     * 求出實際新月點
     * 以2000年初的第一個均值新月點為0點求出的均值新月點和其朔望月之序數 k 代入此副程式來求算實際新月點
     * @param unknown $k
     * @return number
     */
    TrueNewMoon: function ($k) {
        var $jdt, $t, $t2, $t3, $t4, $pt, $m, $mprime, $f, $omega, $es, $apt1, $apt2;
        $jdt = 2451550.09765 + $k * this.synmonth;
        $t = ($jdt - 2451545) / 36525; //2451545為2000年1月1日正午12時的JD
        $t2 = $t * $t; //square for frequent use
        $t3 = $t2 * $t; //cube for frequent use
        $t4 = $t3 * $t; //to the fourth
        //mean time of phase
        $pt = $jdt + 0.0001337 * $t2 - 0.00000015 * $t3 + 0.00000000073 * $t4;
        //Sun's mean anomaly(地球繞太阳运行均值近點角)(從太阳觀察)
        $m = 2.5534 + 29.10535669 * $k - 0.0000218 * $t2 - 0.00000011 * $t3;
        //Moon's mean anomaly(月球繞地球运行均值近點角)(從地球觀察)
        $mprime = 201.5643 + 385.81693528 * $k + 0.0107438 * $t2 + 0.00001239 * $t3 - 0.000000058 * $t4;
        //Moon's argument of latitude(月球的緯度參數)
        $f = 160.7108 + 390.67050274 * $k - 0.0016341 * $t2 - 0.00000227 * $t3 + 0.000000011 * $t4;
        //Longitude of the ascending node of the lunar orbit(月球繞日运行軌道升交點之經度)
        $omega = 124.7746 - 1.5637558 * $k + 0.0020691 * $t2 + 0.00000215 * $t3;
        //乘式因子
        $es = 1 - 0.002516 * $t - 0.0000074 * $t2;
        //因perturbation造成的偏移：
        $apt1 = -0.4072 * Math.sin((Math.PI / 180) * $mprime);
        $apt1 += 0.17241 * $es * Math.sin((Math.PI / 180) * $m);
        $apt1 += 0.01608 * Math.sin((Math.PI / 180) * 2 * $mprime);
        $apt1 += 0.01039 * Math.sin((Math.PI / 180) * 2 * $f);
        $apt1 += 0.00739 * $es * Math.sin((Math.PI / 180) * ($mprime - $m));
        $apt1 -= 0.00514 * $es * Math.sin((Math.PI / 180) * ($mprime + $m));
        $apt1 += 0.00208 * $es * $es * Math.sin((Math.PI / 180) * (2 * $m));
        $apt1 -= 0.00111 * Math.sin((Math.PI / 180) * ($mprime - 2 * $f));
        $apt1 -= 0.00057 * Math.sin((Math.PI / 180) * ($mprime + 2 * $f));
        $apt1 += 0.00056 * $es * Math.sin((Math.PI / 180) * (2 * $mprime + $m));
        $apt1 -= 0.00042 * Math.sin((Math.PI / 180) * 3 * $mprime);
        $apt1 += 0.00042 * $es * Math.sin((Math.PI / 180) * ($m + 2 * $f));
        $apt1 += 0.00038 * $es * Math.sin((Math.PI / 180) * ($m - 2 * $f));
        $apt1 -= 0.00024 * $es * Math.sin((Math.PI / 180) * (2 * $mprime - $m));
        $apt1 -= 0.00017 * Math.sin((Math.PI / 180) * $omega);
        $apt1 -= 0.00007 * Math.sin((Math.PI / 180) * ($mprime + 2 * $m));
        $apt1 += 0.00004 * Math.sin((Math.PI / 180) * (2 * $mprime - 2 * $f));
        $apt1 += 0.00004 * Math.sin((Math.PI / 180) * (3 * $m));
        $apt1 += 0.00003 * Math.sin((Math.PI / 180) * ($mprime + $m - 2 * $f));
        $apt1 += 0.00003 * Math.sin((Math.PI / 180) * (2 * $mprime + 2 * $f));
        $apt1 -= 0.00003 * Math.sin((Math.PI / 180) * ($mprime + $m + 2 * $f));
        $apt1 += 0.00003 * Math.sin((Math.PI / 180) * ($mprime - $m + 2 * $f));
        $apt1 -= 0.00002 * Math.sin((Math.PI / 180) * ($mprime - $m - 2 * $f));
        $apt1 -= 0.00002 * Math.sin((Math.PI / 180) * (3 * $mprime + $m));
        $apt1 += 0.00002 * Math.sin((Math.PI / 180) * (4 * $mprime));

        $apt2 = 0.000325 * Math.sin((Math.PI / 180) * (299.77 + 0.107408 * $k - 0.009173 * $t2));
        $apt2 += 0.000165 * Math.sin((Math.PI / 180) * (251.88 + 0.016321 * $k));
        $apt2 += 0.000164 * Math.sin((Math.PI / 180) * (251.83 + 26.651886 * $k));
        $apt2 += 0.000126 * Math.sin((Math.PI / 180) * (349.42 + 36.412478 * $k));
        $apt2 += 0.00011 * Math.sin((Math.PI / 180) * (84.66 + 18.206239 * $k));
        $apt2 += 0.000062 * Math.sin((Math.PI / 180) * (141.74 + 53.303771 * $k));
        $apt2 += 0.00006 * Math.sin((Math.PI / 180) * (207.14 + 2.453732 * $k));
        $apt2 += 0.000056 * Math.sin((Math.PI / 180) * (154.84 + 7.30686 * $k));
        $apt2 += 0.000047 * Math.sin((Math.PI / 180) * (34.52 + 27.261239 * $k));
        $apt2 += 0.000042 * Math.sin((Math.PI / 180) * (207.19 + 0.121824 * $k));
        $apt2 += 0.00004 * Math.sin((Math.PI / 180) * (291.34 + 1.844379 * $k));
        $apt2 += 0.000037 * Math.sin((Math.PI / 180) * (161.72 + 24.198154 * $k));
        $apt2 += 0.000035 * Math.sin((Math.PI / 180) * (239.56 + 25.513099 * $k));
        $apt2 += 0.000023 * Math.sin((Math.PI / 180) * (331.55 + 3.592518 * $k));
        return $pt + $apt1 + $apt2;
    },
    /**
     * 對於指定日期時刻所屬的朔望月,求出其均值新月點的月序數
     * @param float $jd
     * @return int
     */
    MeanNewMoon: function ($jd) {
        var $kn, $jdt, $t, $thejd;
        //$kn為從2000年1月6日14時20分36秒起至指定年月日之阴曆月數,以synodic month為單位
        $kn = Math.floor(($jd - 2451550.09765) / this.synmonth); //2451550.09765為2000年1月6日14時20分36秒之JD值.
        $jdt = 2451550.09765 + $kn * this.synmonth;
        //Time in Julian centuries from 2000 January 0.5.
        $t = ($jdt - 2451545) / 36525; //以100年為單位,以2000年1月1日12時為0點
        $thejd = $jdt + 0.0001337 * $t * $t - 0.00000015 * $t * $t * $t + 0.00000000073 * $t * $t * $t * $t;
        //2451550.09765為2000年1月6日14時20分36秒,此為2000年後的第一個均值新月
        return [$kn, $thejd];
    },
    /**
     * 将儒略日历时间转换为公历(格里高利历)时间
     * @param float $jd
     * @return array(年,月,日,时,分,秒)
     */
    Julian2Solar: function ($jd, $utc = true) {

        var $y4h, $init, $jdr, $yh, $cen, $d, $ywl, $jy, $d, $ml, $mp, $y, $m, $sd, $mt, $ss, $hh, $yy, $mm, $dd
        if ($utc) {
            $jd -= this.deltatT2($jd - this.J2000);
        }

        //$jd = (float)$jd;

        if ($jd >= 2299160.5) { //1582年10月15日,此日起是儒略日历,之前是儒略历
            $y4h = 146097;
            $init = 1721119.5;
        } else {
            $y4h = 146100;
            $init = 1721117.5;
        }
        $jdr = Math.floor($jd - $init);
        $yh = $y4h / 4;
        $cen = Math.floor(($jdr + 0.75) / $yh);
        $d = Math.floor($jdr + 0.75 - $cen * $yh);
        $ywl = 1461 / 4;
        $jy = Math.floor(($d + 0.75) / $ywl);
        $d = Math.floor($d + 0.75 - $ywl * $jy + 1);
        $ml = 153 / 5;
        $mp = Math.floor(($d - 0.5) / $ml);
        $d = Math.floor(($d - 0.5) - 30.6 * $mp + 1);
        $y = (100 * $cen) + $jy;
        $m = ($mp + 2) % 12 + 1;
        if ($m < 3) {
            $y = $y + 1;
        }
        $sd = Math.floor(($jd + 0.5 - Math.floor($jd + 0.5)) * 24 * 60 * 60 + 0.00005);
        $mt = Math.floor($sd / 60);
        $ss = $sd % 60;
        $hh = Math.floor($mt / 60);
        $mt = $mt % 60;
        $yy = Math.floor($y);
        $mm = Math.floor($m);
        $dd = Math.floor($d);

        return [$yy, $mm, $dd, $hh, $mt, $ss];
    },
    /**
     * 以比較日期法求算冬月及其餘各月名稱代碼,包含閏月,冬月為0,臘月為1,正月為2,餘類推.閏月多加0.5
     * @param int $yy
     */

    GetZQandSMandLunarMonthCode: function ($yy) {
        var $mc, $jdzq, $jdnm, $yz, $i;
        $mc = [];

        $jdzq = this.GetZQsinceWinterSolstice($yy); //取得以前一年冬至為起點之連續15個中氣
        $jdnm = this.GetSMsinceWinterSolstice($yy, $jdzq[0]); //求出以含冬至中氣為阴曆11月(冬月)開始的連續16個朔望月的新月點
        $yz = 0; //設定旗標,0表示未遇到閏月,1表示已遇到閏月
        if (Math.floor($jdzq[12] + 0.5) >= Math.floor($jdnm[13] + 0.5)) { //若第13個中氣jdzq(12)大於或等於第14個新月jdnm(13)
            for ($i = 1; $i <= 14; $i++) { //表示此兩個冬至之間的11個中氣要放到12個朔望月中,
                //至少有一個朔望月不含中氣,第一個不含中氣的月即為閏月
                //若阴曆臘月起始日大於冬至中氣日,且阴曆正月起始日小於或等於大寒中氣日,則此月為閏月,其餘同理
                if (Math.floor(($jdnm[$i] + 0.5) > Math.floor($jdzq[$i - 1 - $yz] + 0.5) && Math.floor($jdnm[$i + 1] + 0.5) <= Math.floor($jdzq[$i - $yz] + 0.5))) {
                    $mc[$i] = $i - 0.5;
                    $yz = 1; //標示遇到閏月
                } else {
                    $mc[$i] = $i - $yz; //遇到閏月開始,每個月號要減1
                }
            }
        } else { //否則表示兩個連續冬至之間只有11個整月,故無閏月
            for ($i = 0; $i <= 12; $i++) { //直接賦予這12個月月代碼
                $mc[$i] = $i;
            }
            for ($i = 13; $i <= 14; $i++) { //處理次一置月年的11月與12月,亦有可能含閏月
                //若次一阴曆臘月起始日大於附近的冬至中氣日,且阴曆正月起始日小於或等於大寒中氣日,則此月為閏月,次一正月同理.
                if (Math.floor(($jdnm[$i] + 0.5) > Math.floor($jdzq[$i - 1 - $yz] + 0.5) && Math.floor($jdnm[$i + 1] + 0.5) <= Math.floor($jdzq[$i - $yz] + 0.5))) {
                    $mc[$i] = $i - 0.5;
                    $yz = 1; //標示遇到閏月
                } else {
                    $mc[$i] = $i - $yz; //遇到閏月開始,每個月號要減1
                }
            }
        }
        return [$jdzq, $jdnm, $mc];
    },
    /**
     * 求算以含冬至中氣為阴曆11月開始的連續16個朔望月
     * @param int $yy 年份
     * @param float $jdws 冬至的儒略日历时间
     * @return array
     */
    GetSMsinceWinterSolstice: function ($yy, $jdws) {
        var $tjd, $jd, $kn, $thejd, $arr, $i, $k, $mjd, $j, $jdnm;
        $tjd = [];
        $jd = this.Solar2Julian($yy - 1, 11, 1, 0, 0, 0); //求年初前兩個月附近的新月點(即前一年的11月初)


        $arr = this.MeanNewMoon($jd); //求得自2000年1月起第kn個平均朔望日及其JD值
        $kn = $arr[0];
        $thejd = $arr[1];

        for ($i = 0; $i <= 19; $i++) { //求出連續20個朔望月
            $k = $kn + $i;
            $mjd = $thejd + this.synmonth * $i;
            $tjd[$i] = this.TrueNewMoon($k) + 1 / 3; //以k值代入求瞬時朔望日,因中國比格林威治先行8小時,加1/3天
            //下式為修正dynamical time to Universal time
            $tjd[$i] = $tjd[$i] - this.DeltaT($yy, $i - 1) / 1440; //1為1月,0為前一年12月,-1為前一年11月(當i=0時,i-1=-1,代表前一年11月)
        }
        for ($j = 0; $j <= 18; $j++) {
            if (Math.floor($tjd[$j] + 0.5) > Math.floor($jdws + 0.5)) {
                break;
            } //已超過冬至中氣(比較日期法)
        }

        $jdnm = [];
        for ($k = 0; $k <= 15; $k++) { //取上一步的索引值
            $jdnm[$k] = $tjd[$j - 1 + $k]; //重排索引,使含冬至朔望月的索引為0
        }
        return $jdnm;
    },
    /**
     * 將公历时间转换为儒略日历时间
     * @param int $yy
     * @param int $mm
     * @param int $dd
     * @param int $hh [0-23]
     * @param int $mt [0-59]
     * @param int $ss [0-59]
     * @return boolean|number
     */
    Solar2Julian_bak: function ($yy, $mm, $dd, $hh = 0, $mt = 0, $ss = 0) {
        var $yp, $init, $jdy, $mp, $jdm, $jdd, $jdh;
        if (!this.ValidDate($yy, $mm, $dd)) {
            return false;
        }
        if ($hh < 0 || $hh >= 24) {
            return false;
        }
        if ($mt < 0 || $mt >= 60) {
            return false;
        }
        if ($ss < 0 || $ss >= 60) {
            return false;
        }

        $yp = $yy + Math.floor(($mm - 3) / 10);
        if (($yy > 1582) || ($yy == 1582 && $mm > 10) || ($yy == 1582 && $mm == 10 && $dd >= 15)) { //这一年有十天是不存在的
            $init = 1721119.5;
            $jdy = Math.floor($yp * 365.25) - Math.floor($yp / 100) + Math.floor($yp / 400);
        }
        if (($yy < 1582) || ($yy == 1582 && $mm < 10) || ($yy == 1582 && $mm == 10 && $dd <= 4)) {
            $init = 1721117.5;
            $jdy = Math.floor($yp * 365.25);
        }
        if (!$init) {
            return false;
        }
        $mp = Math.floor($mm + 9) % 12;
        $jdm = $mp * 30 + Math.floor(($mp + 1) * 34 / 57);
        $jdd = $dd - 1;
        $jdh = ($hh + ($mt + ($ss / 60)) / 60) / 24;
        return $jdy + $jdm + $jdd + $jdh + $init;
    },
    Solar2Julian: function(y,m,d,h = 0,i = 0,s = 0){
        d	=	d+(h*3600+i*60+s)/86400;
        var n=0, G=0;
        if(y*372+m*31+Math.floor(d)>=588829) G=1; //判断是否为格里高利历日1582*372+10*31+15
        if(m<=2) m+=12, y--;
        if(G) n=Math.floor(y/100), n=2-n+Math.floor(n/4); //加百年闰
        return Math.floor(365.25*(y+4716)) + Math.floor(30.6001*(m+1))+d+n - 1524.5;
    },
    /**
     * 判断公历日期是否有效
     * @param int $yy
     * @param int $mm
     * @param int $dd
     * @return boolean
     */
    ValidDate: function ($yy, $mm, $dd) {
        var $ndf1, $ndf2, $ndf, $dom;
        if ($yy < -1000 || $yy > 3000) { //适用于西元-1000年至西元3000年,超出此范围误差较大
            return false;
        }

        if ($mm < 1 || $mm > 12) { //月份超出範圍
            return false;
        }

        if ($yy == 1582 && $mm == 10 && $dd >= 5 && $dd < 15) { //这段日期不存在.所以1582年10月只有20天
            return false;
        }

        $ndf1 = -($yy % 4 == 0); //可被四整除
        $ndf2 = (($yy % 400 == 0) - ($yy % 100 == 0)) && ($yy > 1582);
        $ndf = $ndf1 + $ndf2;
        $dom = 30 + ((Math.abs($mm - 7.5) + 0.5) % 2) - Number($mm == 2) * (2 + $ndf);
        if ($dd <= 0 || $dd > $dom) {
            if ($ndf == 0 && $mm == 2 && $dd == 29) { //此年無閏月

            } else { //日期超出範圍

            }
            return false;
        }

        return true;
    },

    // 算出:jd转到当地UTC后,UTC日数的整数部分或小数部分
    // 基于J2000力学时jd的起算点是12:00:00时,所以跳日时刻发生在12:00:00,这与日历计算发生矛盾
    // 把jd改正为00:00:00起算,这样儒略日的跳日动作就与日期的跳日同步
    // 改正方法为jd=jd+0.5-deltatT+shiqu/24.0
    // 把儒略日的起点移动-0.5(即前移12小时)
    // 式中shiqu是时区,北京的起算点是-8小时,shiqu取8
    Dint_dec: function( jd, shiqu, dec) {
        var u = jd + 0.5 - this.deltatT2(jd) + shiqu / 24.0;
        if (dec)
            return Math.floor(u); // 返回整数部分
        else
            return u - Math.floor(u); // 返回小数部分
    },

    paiYue: function(y)
    {


        var zq = [];
        var jq = [];
        var hs = [];
        var num = 15;
        var A=[],B=[],C=[],syn=[];

        var i;



        var t1 = 365.2422 * (y - 2000) - 50; // 农历年首始于前一年的冬至,为了节气中气一起算,取前年大雪之前
        for (var i = 0; i < num; i++) { // 计算节气(从冬至开始),注意:返回的是力学时
            zq[i] = this.jiaoCal(t1 + i * 30.43685, i * 30 - 90, 0); // 中气计算,冬至的太阳黄经是270度(或-90度)
            jq[i] = this.jiaoCal(t1 + i * 30.43685, i * 30 - 105, 0); // 顺便计算节气,它不是农历定朔计算所必需的
        }
        // 在冬至过后,连续计算num个日月合朔时刻
        var dongZhiJia1 = zq[0] + 1 - this.Dint_dec(zq[0], 8, false); // 冬至过后的第一天0点的儒略日数
        hs[0] = this.jiaoCal(dongZhiJia1, 0, 1); // 首月结束的日月合朔时刻
        for (var i = 1; i < num; i++)
            hs[i] = this.jiaoCal(hs[i - 1] + 25, 0, 1);
        // 算出中气及合朔时刻的日数(不含小数的日数计数,以便计算日期之间的差值)

        // var A=new Array(), B=new Array(), C=new Array();
        for (var i = 0; i < num; i++) { // 取当地UTC日数的整数部分
            A[i] = this.Dint_dec(zq[i], 8, true);
            B[i] = this.Dint_dec(jq[i], 8, true);
            C[i] = this.Dint_dec(hs[i], 8, true);
        }
        // 闰月及大小月分析
        var tot = 12, nun = -1;
        var yn = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 0, 0]; // 月编号
        if (C[12] <= A[12]) { // 闰月分析
            yn[12] = 12;
            tot = 13; // 编号为12的月是本年的有效月份,本年总月数13个
            for (i = 1; i < 13; i++){
                if (C[i] <= A[i])
                    break;
            }

            for (nun = i - 1; i < 13; i++){
                yn[i - 1]--; // 注意yn中不含农历首月(所以取i-1),在公历中农历首月总是去年的所以不多做计算
            }

        }

        for (var i = 0; i < tot; i++) { // 转为建寅月名,并做大小月分析

            var tmp2    =   {};

            tmp2.name   =   this.yueMing[(yn[i] + 10) % 12]; // 转建寅月名

            tmp2.m      =   (yn[i] + 10) % 12+1;

            var msg="";
            msg +=tmp2.name;
            if (i == nun) {
                tmp2.r=1;
                msg += "闰";

            } else {
                tmp2.r=0;
            }
            msg +="月";
            if (C[i + 1] - C[i] > 29) {
                tmp2.day    =   30;
                // msg +="大";

            } else {
                tmp2.day    =   29;
                // msg +="小";

            }
            tmp2.y      =   y;
            tmp2.msg    =   msg;
            if(i==0){
                tmp2.y--;
            }
            syn[i]  =   tmp2;



        }

        var out=[];
        // 显示
        for (var i = 0; i < tot; i++)
        {
            var utcTime  =   this.setFromJD(hs[i] + this.J2000 +  8 / 24, true);


            var tmp =   {};
            tmp.y=  utcTime[0];
            tmp.m=  utcTime[1];
            tmp.d=  utcTime[2];
            tmp.info=  syn[i];
            // var tmp2=  new Date(tmp.y+"/"+tmp.m+"/"+tmp.d+" 00:00:00");
            // tmp.utime   =   tmp2.getTime();
            var $$y, $$m, $$d;
            $$y = this.formatYearNum(tmp.y);
            $$m = UTILS.getTimeStrByInt(tmp.m);
            $$d = UTILS.getTimeStrByInt(tmp.d);
            var tmp2 = $$y  + '-' + $$m + '-' + $$d + ' 00:00:00';
            tmp.utime = MOMENT_TIME.getUnixTimeByTimeStr(tmp2) * 1000;
            // console.log('paiYue----', tmp2)
            out[i]=tmp;
        }

        return out;
    },

    Solar2Lunar_nouse: function ($yy, $mm, $dd)
    {

        var $mi;
        var $prev = 0; //是否跨年了,跨年了则减一
        var $isLeap = 0;//是否闰月
        var $jd;


        var Ypai    = this.GetZQandSMandLunarMonthCode($yy);
        var $jdzq   =  Ypai[0];
        var $jdnm   =  Ypai[1];
        var $mc     =  Ypai[2];

        $jd = this.Solar2Julian($yy, $mm, $dd, 12, 0, 0); //求出指定年月日之JD值
        // Todo 2020.10.06修复1984.1.1的闰月问题 $jdnm[0] -> $jdnm[1]
        if (Math.floor($jd) < Math.floor($jdnm[1] + 0.5)) {
            $prev = 1;
            Ypai = this.GetZQandSMandLunarMonthCode($yy - 1);


            $jdzq   =  Ypai[0];
            $jdnm   =  Ypai[1];
            $mc     =  Ypai[2];
        }
        for (var $i = 0; $i <= 14; $i++) { //指令中加0.5是為了改為從0時算起而不從正午算起
            if (Math.floor($jd) >= Math.floor($jdnm[$i] + 0.5) && Math.floor($jd) < Math.floor($jdnm[$i + 1] + 0.5)) {
                $mi = $i;
                break;
            }
        }

        if ($mc[$mi] < 2 || $prev == 1) { //年
            $yy = $yy - 1;
        }

        if (($mc[$mi] - Math.floor($mc[$mi])) * 2 + 1 != 1) { //因mc(mi)=0對應到前一年阴曆11月,mc(mi)=1對應到前一年阴曆12月,mc(mi)=2對應到本年1月,依此類推
            $isLeap = 1;
        }
        $mm = (Math.floor($mc[$mi] + 10) % 12) + 1; //月

        $dd = Math.floor($jd) - Math.floor($jdnm[$mi] + 0.5) + 1; //日,此處加1是因為每月初一從1開始而非從0開始

        var newday  =   {};
        newday.y    =   $yy;
        newday.m    =   $mm;
        newday.r    =   $isLeap;
        newday.msg    = this.yueMing[$mm]+"月";
        newday.d  =   $dd;
        return newday;

    },

    /**
     * 将公历时间转换成农历时间
     * @param int $yy
     * @param int $mm
     * @param int $dd
     * @return array(年,月,日,是否闰月)
     */
    Solar2Lunar: function ($yy, $mm, $dd)
    {
        var n1  =   this.paiYue($yy-1);
        var n2  =   this.paiYue($yy);
        var n4  =   this.paiYue($yy+1);

        //console.log('公历转农历--------', $yy+"/"+$mm+"/"+$dd+ " 00:00:00")
        var $$y, $$m, $$d;
        $$y = this.formatYearNum($yy);
        $$m = UTILS.getTimeStrByInt($mm);
        $$d = UTILS.getTimeStrByInt($dd);
        var tmpDate = $$y  + '-' + $$m + '-' + $$d + ' 12:00:00';
        var utime = MOMENT_TIME.getUnixTimeByTimeStr(tmpDate) * 1000;
        //console.log('公历转农历-------', tmpDate, utime)

        var tmpDate2 =   new Date($yy+"/"+$mm+"/"+$dd+ " 00:00:00");
        var utime2   =   tmpDate2.getTime();
        //console.log('公历转农历:::date方式--------', tmpDate2, utime2)

        var n3  =   n1; //合并的
        var i;

        for(i=0;i<n2.length;i++){
            n3[n3.length]   =   n2[i];
        }
        for(i=0;i<n4.length;i++){
            n3[n3.length]   =   n4[i];
        }

        var num =   n3.length;
        var i,wei;
        for(i=0;i<num;i++)
        {
            if(utime>=n3[i].utime && utime<n3[i+1].utime){
                wei =   i;
                break;
            }
        }

        var newday  =   {};

        //console.log("---------here--"+$yy+"---"+$mm+"---"+$dd);
        //console.log(n1);
        //console.log(n2);
        //console.log(n3);
        //console.log(wei);


        //定位到了正确的时间点了 那么开始加了
        var chaday  =   (utime-n3[wei].utime)/86400000;//相差这么多天
        chaday = Math.floor(chaday);
        chaday++;//每个月是1开始的 不是0
        if(chaday>n3[wei].info.day){
            chaday  =   chaday-n3[wei].info.day;
            wei++;//加一个月
            newday.y    =   n3[wei].info.y;
            newday.m    =   n3[wei].info.m;
            newday.r    =   n3[wei].info.r;
            newday.msg    =   n3[wei].info.msg;
            newday.d  =   chaday;

        }
        else {
            newday.y    =   n3[wei].info.y;
            newday.m    =   n3[wei].info.m;
            newday.r    =   n3[wei].info.r;
            newday.msg    =   n3[wei].info.msg;
            newday.d  =   chaday;
        }

        return newday;


    },

    /**
     * 将农历时间转换成公历时间
     * @param int $yy
     * @param int $mm
     * @param int $dd
     * @return array(年,月,日,是否闰月)
     */
    Lunar2Solar: function ($yy, $mm, $dd, $r=0)
    {

        var n2  =   this.paiYue($yy+1);
        var n3  =   this.paiYue($yy);

        var n4  =   this.paiYue($yy+1);



        // var tmpDate =   new Date($yy+"/"+$mm+"/"+$dd+ " 00:00:00");
        // var utime   =   tmpDate.getTime();
        console.log('农历转公历--------', $yy+"/"+$mm+"/"+$dd+ " 00:00:00")
        var $$y, $$m, $$d;
        $$y = this.formatYearNum($yy);
        $$m = UTILS.getTimeStrByInt($mm);
        $$d = UTILS.getTimeStrByInt($dd);
        var tmpDate = $$y  + '-' + $$m + '-' + $$d + ' 12:00:00';
        var utime = MOMENT_TIME.getUnixTimeByTimeStr(tmpDate) * 1000;

        for(var i=0;i<n2.length;i++){
            n3[n3.length]   =   n2[i];
        }

        for(var i=0;i<n4.length;i++){
            n3[n3.length]   =   n4[i];
        }
        var num =   n3.length;
        var i,wei,num;

        for(i=0;i<num;i++){
            if(n3[i].info.m==$mm && n3[i].info.y==$yy && n3[i].info.r==$r){
                wei =   i;
                break;
            }
        }

        var newday  =   {};

        //定位到了正确的时间点了 那么开始加了
        var chaday  =   $dd;
        chaday--;//每个月是1开始的 不是0
        if(!wei){
            return null;
        }
        var now =   n3[wei].utime+chaday*86400000+43200000;
        newday = this.formatDate("ymd",now,false);
        return newday;
    },

    /**
     * 给年补齐4位数
     * @param {年} $yy
     */
    formatYearNum: function ($yy) {
        var $num = 4 - $yy.toString().length;
        for(var $i = 0; $i < $num; $i++){
            $yy = '0' + $yy;
        }
        return $yy;
    },

    /**
     * 四柱計算,分早子时晚子时,传公历
     * @param int $yy
     * @param int $mm
     * @param int $dd
     * @param int $hh 时间(0-23)
     * @param int $mt 分钟数(0-59),在跨节的时辰上会需要,有的排盘忽略了跨节
     * @param int $ss 秒数(0-59)
     * @return array(天干, 地支, 对应的儒略日历时间, 对应年的12节+前后N节, 对应时间所处节的索引)
     */
    GetGanZhi: function ($yy, $mm, $dd, $hh, $mt = 0, $ss = 0, $dtime = 0) {
        var $jd, $tg, $dz, $jq, $ygz, $ix, $j;
        // console.log('GetGanZhi------', $yy, $mm, $dd, $hh, $mt, $ss)

        $jd = this.Solar2Julian($yy, $mm, $dd, $hh, $mt, Math.max(1, $ss));
        // console.log('$jd------', $jd)

        if (!$jd) { //多加一秒避免精度问题
            return [];
        }


        $tg = [];
        $dz = [];

        $jq = this.GetPureJQsinceSpring($yy); //取得自立春開始的节,该数组长度固定为16


        if ($jd < $jq[1]) { //jq[1]為立春,約在2月5日前後,
            $yy = $yy - 1; //若小於jq[1],則屬於前一個節氣年
            $jq = this.GetPureJQsinceSpring($yy); //取得自立春開始的节
        }

        $ygz = (($yy + 4712 + 24) % 60 + 60) % 60;
        $tg[0] = $ygz % 10; //年干
        $dz[0] = $ygz % 12; //年支
        // console.log('nian-----', $yy, $tg[0], $dz[0], $jd, $jq)

        for ($j = 0; $j <= 15; $j++) { //比較求算節氣月,求出月干支
            if ($jq[$j] > $jd) { //已超過指定時刻,故應取前一個節氣
                $ix = $j - 1;
                break;
            }
        }
        /**

         $tmm = (($yy + 4712) * 12 + ($ix - 1) + 60) % 60; //数组0为前一年的小寒所以这里再减一
         $mgz = ($tmm + 50) % 60;
         $tg[1] = $mgz % 10; //月干
         $dz[1] = $mgz % 12; //月支

         */
            //五虎遁 算月
        var $yue = this.getLiuNianSLiuYue($tg[0]);
        $tg[1] = $yue[$ix - 1]['g'];
        $dz[1] = $yue[$ix - 1]['z'];


        //高斯算法
        var $ri = this.getRizhuIndex($dtime);
        $tg[2] = $ri['g'] % 10; //日干
        $dz[2] = $ri['z'] % 12; //日支

        var $shi = this.getLiuRISLiuShi($tg[2]);
        var $sv;
        for (var $i = 0; $i < $shi.length; $i++) {
            $sv = $shi[$i];
            if ($sv['beg'] <= $hh && $sv['end'] > $hh) {
                $tg[3] = $sv['g'] % 10; //時干
                $dz[3] = $sv['z'] % 12; //時支
                break;
            }
        }

        //  console.log('getGanZhi----', this.zwz);
        //  区分早晚子时，不会改变时柱
        if (this.zwz) { //区分早晚子时,日柱前移一柱
            if($hh >= 23)
            {
                $tg[2] = ($tg[2] + 10 + 1) % 10;
                $dz[2] = ($dz[2] + 12 + 1) % 12;
            }
        }

        // console.log('getGanZhi---', $tg, $dz, $jd, $jq, $ix)
        return [$tg, $dz, $jd, $jq, $ix];
    },

    /**
     * 相同四柱的年份计算,传天干地支数组,开始及结束年份
     * @param {天干数组} $tg
     * @param {地支数组} $dz
     * @param {开始年份} $start
     * @param {结束年份} $end
     * @return array([year, month, day, hour])
     */
    GetSameGanZhiList_bak: function ($tg, $dz, $start, $end) {
        // console.log('GetSameGanZhiList----', $tg, $dz, $start, $end)
        var $oneY, $sY = $start, $ttg = [], $tdz = [], $rt = [];
        // 获得第一个年柱相同的年份及年柱相同的年份list
        while($sY < $end){
            var $ygz = (($sY + 4712 + 24) % 60 + 60) % 60;
            $ttg[0] = $ygz % 10; //年干
            $tdz[0] = $ygz % 12; //年支
            // console.log('--------$sY', $sY, $ttg[0], $tdz[0], $tg[0], $dz[0]);
            if($ttg[0] == $tg[0] && $tdz[0] == $dz[0]){
                $oneY = $sY;
                // console.log('--------$oneY', $oneY);
                break;
            }
            $sY++;
        }

        // 轮询同四柱的年月日时
        while($oneY <= $end){
            var $yue = this.getLiuYue($oneY);
            for(var $yy of $yue) {
                // console.log('--------$yy', $yy, $ri);
                if($yy.g == $tg[1] && $yy.z == $dz[1]) {
                    var $ri = this.getLiuRi($yy.begtime, $yy.endtime);
                    for(var $rr of $ri) {
                        if($rr.g == $tg[2] && $rr.z == $dz[2]) {
                            var $shi = this.getLiuRISLiuShi($rr.g)
                            for(var $ss of $shi) {
                                if($ss.g == $tg[3] && $ss.z == $dz[3]){
                                    // 注:月份取getLiuRi返回的m
                                    $rt.push([$oneY, $rr.m, $rr.d, $ss.beg])
                                }
                            }
                        }
                    }
                }
            }
            $oneY = $oneY + 60;
        }
        // console.log('--------$rt', $rt);
        // console.log('-----$sY', $sY, $oneY, $ttg, $tdz);

        // 注:多做一步反向校验
        $rt.forEach($arr => {
            // console.log('$arrr----', $arr)
            var $gz = this.GetGanZhi($arr[0], $arr[1], $arr[2], $arr[3]),
                $ntg = $gz[0], $ndz = $gz[1];
            console.log('ret--------', $ntg, $tg, $ndz, $dz);
            if($ntg[0] == $tg[0] && $ndz[0] == $dz[0] &&
                $ntg[1] == $tg[1] && $ndz[1] == $dz[1] &&
                $ntg[2] == $tg[2] && $ndz[2] == $dz[2] &&
                $ntg[3] == $tg[3] && $ndz[3] == $dz[3]){
                console.log('OK----')
            }else{
                $arr[0] = $arr[0] + 1;
            }
        })

        return $rt;
    },

    GetSameGanZhiList: function ($tg, $dz, $start, $end) {
        var $this   =   this;
        //选一个甲子年2044 得到当前往后最近的一个甲子年
        let $jzy = 2104;
        let $nowy = $end;
        while ($nowy >= $jzy) {
            $jzy += 60;
        }

        let $ydiff = this.array_search(this.ctg[$tg[0]]+this.cdz[$dz[0]], this.jiazhi);
        let $beg = Math.floor($jzy) + Math.floor($ydiff);
        let $yArr = [];
        for (let $i = $beg; $i >= 60; $i = $i - 60) {
            if ($i > $start && $i <= $nowy) {
                $yArr[$yArr.length] = $i;
            }
        }

        //年弄出来了
        var $timeArr = [];
        $yArr.forEach(function ($v,$k,$input) {
            let $liuyue = $this.getLiuYue($v);
            $liuyue.forEach(function ($v2,$k2,$input2) {
                // console.log('$liuyue--------', $v2)
                if ($v2['g'] == $tg[1] && $v2['z'] == $dz[1]) {
                    //存在这个流月
                    //查找流日
                    let $liuri = $this.getLiuRi($v2['begtime'], $v2['endtime'] + 86400000);
                    //console.log('$liuri---------', $liuri)
                    $liuri.forEach(function ($v3) {
                        if ($v3['g'] == $tg[2] && $v3['z'] == $dz[2]) {
                            var $lastObj={};
                            //存在流月，找流时
                            $lastObj.y = $v3['y'];
                            $lastObj.m = $v3['m'];
                            $lastObj.d = $v3['d'];
                            $lastObj.i = $v3['i'];
                            $lastObj.s = $v3['s'];
                            $lastObj.h = 0;
                            let $liushi = $this.getLiuRISLiuShi($v3['g']);

                            $liushi.forEach(function ($v4) {

                                if ($v4['g'] == $tg[3] && $v4['z'] == $dz[3]) {

                                    $lastObj.h= $v4['beg'];
                                    var $$y, $$m, $$d, $$h, $$i, $$s;
                                    $$y = $this.formatYearNum($lastObj.y);
                                    $$m = UTILS.getTimeStrByInt($lastObj.m);
                                    $$d = UTILS.getTimeStrByInt($lastObj.d);
                                    $$h = UTILS.getTimeStrByInt($lastObj.h);
                                    $$i = UTILS.getTimeStrByInt($lastObj.i);
                                    $$s = UTILS.getTimeStrByInt($lastObj.s);
                        
                                    var $lastObjTime = $$y + '-' + $$m + '-' + $$d + ' ' + $$h + ':' + $$i + ':' + $$s,
                                        $lastObjUnixTime = MOMENT_TIME.getUnixTimeByTimeStr($lastObjTime) * 1000;
                                    //console.log('sizhu--------', $lastObj, $lastObjTime, $lastObjUnixTime, $v2['endtime'])
                                    if($lastObjUnixTime < $v2['endtime'] && $lastObjUnixTime>$v2['begtime']) {
                                        $timeArr[$timeArr.length] = $lastObj;
                                    }
                                }
                            });
                        }
                    })
                }
            })
        })
        return $timeArr;
    },

    array_search: function(str,array){
        if(typeof array !== 'object'){
            return false;
        }else{
            var found = [];
            for(var i in array){
                if(array[i]==str){
                    found.push(i);
                }
            }
            var num = found.length;
            if(num==0) return false;
            if(num==1) return found[0];
            return found;
        }
    },

    /**
     * 获取年号
     * @param {年} y
     */
    GetNianHao: function (y) {
        y = Math.floor(y);
        let all = chaodai.CONST_CHAO_DAI;
        let low =   0;
        let height = all.length-1;
        let mid;
        let find=-1;

        while(low<=height){
            mid=Math.floor((low+height)/2);
            if(all[mid].b<=y && all[mid].e>y) {
                find= mid;
                break;
            }else if(all[mid].b<y){
                low=mid+1;
            }else{
                height=mid-1;
            }
        }
        if(find!=-1){
            var ret =   all[find];
            ret.cha =   this.convertToChinaNum(y-ret.b+1);
            return ret;
        }
        return false;
    },

    convertToChinaNum: function (num) {
        var arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
        var arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千','万', '十', '百', '千','亿');//可继续追加更高位转换值
        if(!num || isNaN(num)){
            return "零";
        }
        var english = num.toString().split("")
        var result = "";
        for (var i = 0; i < english.length; i++) {
            var des_i = english.length - 1 - i;//倒序排列设值
            result = arr2[i] + result;
            var arr1_index = english[des_i];
            result = arr1[arr1_index] + result;
        }
        //将【零千、零百】换成【零】 【十零】换成【十】
        result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
        //合并中间多个零为一个零
        result = result.replace(/零+/g, '零');
        //将【零亿】换成【亿】【零万】换成【万】
        result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
        //将【亿万】换成【亿】
        result = result.replace(/亿万/g, '亿');
        //移除末尾的零
        result = result.replace(/零+$/, '')
        //将【零一十】换成【零十】
        //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
        //将【一十】换成【十】
        result = result.replace(/^一十/g, '十');
        return result;
    },

    formatDate: function (type, time, $untime = true) {

        if($untime){
            var utime = time * 1000;
        }
        else{
            var utime = time * 1;
        }

        // var now = new Date(utime);
        // format格式 'YYYY-MM-DD HH:mm:ss ZZ'
        var timeArr = MOMENT_TIME.getTimeArrayByTimeStamp(utime);
        // console.log("formatDate-------", time, utime, timeArr);

        var val;
        switch (type) {
            case "Y":
                // val = now.getFullYear();
                val = timeArr[0];
                break;

            case "n":
            case "m":
                // val = now.getMonth() + 1;
                val = timeArr[1];
                break;
            case "j":
            case "d":
                // val = now.getDate();
                val = timeArr[2];
                break;
            case "H":
                // val = now.getHours();
                val = timeArr[3];
                break;
            case "i":
                // val = now.getMinutes()
                val = timeArr[4];
                break;
            case "s":
                // val = now.getSeconds();
                val = timeArr[5];
                break;
            case "ymd":
                var val = {};
                // val['y'] = now.getFullYear();
                // val['m'] = now.getMonth() + 1;
                // val['d'] = now.getDate();
                val['y'] = timeArr[0];
                val['m'] = timeArr[1];
                val['d'] = timeArr[2];
                break;

            default :
                var val = {};
                // val['y'] = now.getFullYear();
                // val['m'] = now.getMonth() + 1;
                // val['d'] = now.getDate();
                // val['h'] = now.getHours();
                // val['i'] = now.getMinutes();
                // val['s'] = now.getSeconds();
                val['y'] = timeArr[0];
                val['m'] = timeArr[1];
                val['d'] = timeArr[2];
                val['h'] = timeArr[3];
                val['i'] = timeArr[4];
                val['s'] = timeArr[5];
                break;

        }

        return val;
    },

    /**
     * @param $gd 0男1女
     * @param $dtime
     * @param $zwzs
     * @return array
     */
    GetInfo: function ($gd, $dtime, $zwzs) {
        var $yy, $mm, $dd, $hh, $mt, $ss,$big_tg, $big_dz, $span;
        $yy = this.formatDate("Y", $dtime);
        $mm = this.formatDate("m", $dtime);
        $dd = this.formatDate("d", $dtime);
        $hh = this.formatDate("H", $dtime);
        $mt = this.formatDate("i", $dtime);
        $ss = this.formatDate("s", $dtime);;

        // 设置早晚子时: 0是23点(不区分)false, 1是24点(区分):true
        this.zwz = $zwzs == 0 ? true : false;
        //echo $yy.$mm.$dd.$hh.$mt;exit;
        // console.error('getinfo-------', $dtime)
        console.log("GetInfo------", $yy, $mm, $dd, $hh, $mt, $zwzs)

        var $ret = {};
        var $big_info = [];
        var $before_info = [];
        var allArr = this.GetGanZhi($yy, $mm, $dd, $hh, $mt, $ss, $dtime);
        var $tg = allArr[0];
        var $dz = allArr[1];
        var $jd = allArr[2];
        var $jq = allArr[3];
        var $ix = allArr[4];
        var $pn = $tg[0] % 2; //起大运.阴阳年干:0阳年1阴年

        
        var $jqall = this.GetAdjustedJQ($yy);

        var jieqi  =   {};


        var jqbeg={},jqmid={},jqend={};
        var jqwei1         =    (($ix-1)*2+1)%24;
        jqbeg.name         =    this.jqall[jqwei1-1];
        jqbeg.time         =    this.setFromJD($jq[$ix]);

        jqmid.name         =    this.jqall[jqwei1];
        jqmid.time         =    this.setFromJD($jqall[$ix+4]);
        
        // 特殊处理最后一位
        jqwei1 = jqwei1 == 23 ? -1 : jqwei1;

        jqend.name         =    this.jqall[jqwei1+1];
        jqend.time         =    this.setFromJD($jq[$ix+1]);
        jieqi['beg']       =    jqbeg;
        jieqi['mid']       =    jqmid;
        jieqi['end']       =    jqend;

        $ret['jieqi']   =   jieqi;


        var $utimeArr, $dateU, $momStr, $utime, $cha, $i, $begTime, begyObj, $begyjq, $begyjd, begy;
        var $$y, $$m, $$d, $$h, $$i, $$s, $$w, btY;


        if (($gd == 0 && $pn == 0) || ($gd == 1 && $pn == 1)) { //起大运时间,阳男阴女顺排
            $span = $jq[$ix + 1] - $jd; //往后数一个节,计算时间跨度


            $utimeArr = this.Julian2Solar($jq[$ix + 1]);//所属气节时间
            // $dateU = new Date($utimeArr[0] + '/' + $utimeArr[1] + "/" + $utimeArr[2] + ' ' + $utimeArr[3] + ':' + $utimeArr[4] + ':' + $utimeArr[5]);
            // $utime = $dateU.getTime();
            // $utime = Math.floor($utime / 1000);
            $$y = this.formatYearNum($utimeArr[0]);
            $$m = UTILS.getTimeStrByInt($utimeArr[1]);
            $$d = UTILS.getTimeStrByInt($utimeArr[2]);
            $$h = UTILS.getTimeStrByInt($utimeArr[3]);
            $$i = UTILS.getTimeStrByInt($utimeArr[4]);
            $$s = UTILS.getTimeStrByInt($utimeArr[5]);
            $momStr =  $$y + '-' + $$m + '-' + $$d + ' ' + $$h + ':' + $$i + ':' + $$s;
            $utime = MOMENT_TIME.getUnixTimeByTimeStr($momStr);

            $cha = $utime - $dtime;

            $begTime = $dtime + $cha * 120;

            begyObj    =   this.formatDate("",$begTime);

            $begyjq = this.getFirstJq(begyObj['y']); //取得这一年的节 立春

            $begyjd =this.Solar2Julian(begyObj['y'], begyObj['m'], begyObj['d'], begyObj['h'], begyObj['i'], begyObj['s']);
            begy    =   begyObj['y'];
            if($begyjd<$begyjq){
                begy--;
            }


            for ($i = 1; $i <= 12; $i++) { //大运干支
                var bigTmp = {};
                bigTmp.tg = ($tg[1] + $i) % 10;
                bigTmp.dz = ($dz[1] + $i) % 12;
                bigTmp.y = begy + (($i - 1) * 10);
                bigTmp.age = begy + (($i - 1) * 10) - $yy+1;
                $big_info[$big_info.length] = bigTmp;
            }

            // 获取起运前的年份数组
            btY = begy - $yy > 0 ? begy - $yy : 0;
            for($$w = 0; $$w < btY; $$w++) {
                var bbigTemp = {};
                bbigTemp.tg = ($tg[0] + 20 + $$w) % 10;
                bbigTemp.dz = ($dz[0] + 24 + $$w) % 12;
                bbigTemp.y = $yy + $$w;
                bbigTemp.age = $$w + 1;
                $before_info[$$w] = bbigTemp;
            }

        } else { // 阴男阳女逆排,往前数一个节

            $span = $jd - $jq[$ix];

            $utimeArr = this.Julian2Solar($jq[$ix]);
            // $dateU = new Date($utimeArr[0] + '/' + $utimeArr[1] + "/" + $utimeArr[2] + ' ' + $utimeArr[3] + ':' + $utimeArr[4] + ':' + $utimeArr[5]);
            // $utime = $dateU.getTime();
            // $utime = Math.floor($utime / 1000);
            $$y = this.formatYearNum($utimeArr[0]);
            $$m = UTILS.getTimeStrByInt($utimeArr[1]);
            $$d = UTILS.getTimeStrByInt($utimeArr[2]);
            $$h = UTILS.getTimeStrByInt($utimeArr[3]);
            $$i = UTILS.getTimeStrByInt($utimeArr[4]);
            $$s = UTILS.getTimeStrByInt($utimeArr[5]);
            $momStr =  $$y + '-' + $$m + '-' + $$d + ' ' + $$h + ':' + $$i + ':' + $$s;
            $utime = MOMENT_TIME.getUnixTimeByTimeStr($momStr);

            $cha = $dtime - $utime;

            $begTime = $dtime + $cha * 120;

            begyObj    =   this.formatDate("",$begTime);

            $begyjq = this.getFirstJq(begyObj['y']); //取得这一年的节 立春


            $begyjd = this.Solar2Julian(begyObj['y'], begyObj['m'], begyObj['d'], begyObj['h'], begyObj['i'], begyObj['s']);
            begy    =   begyObj['y'];
            if($begyjd<$begyjq){
                begy--;
            }
            // console.error('begyObj------', begyObj, begy, $yy)

            for ($i = 1; $i <= 12; $i++) { //确保是正数
                var bigTmp  =   {};
                bigTmp.tg   =   ($tg[1] + 20 - $i) % 10;
                bigTmp.dz   =   ($dz[1] + 24 - $i) % 12;
                bigTmp.y    =   begy+(($i-1)*10);
                bigTmp.age  =   begy+(($i-1)*10)-$yy+1;//虚岁+1
                $big_info[$big_info.length] =   bigTmp;
            }

            // 获取起运前的年份数组
            btY = begy - $yy > 0 ? begy - $yy : 0;
            for($$w = 0; $$w < btY; $$w++) {
                var bbigTemp = {};
                bbigTemp.tg = ($tg[0] + 20 + $$w) % 10;
                bbigTemp.dz = ($dz[0] + 24 + $$w) % 12;
                bbigTemp.y = $yy + $$w;
                bbigTemp.age = $$w + 1;
                $before_info[$$w] = bbigTemp;
            }

        }


        var $start_jdtime = $jd + $span * 120; //三天折合一年,一天折合四个月,一个时辰折合十天,一个小时折合五天,反推得到一年按360天算

        var $days = Math.floor($span * 4 * 30); //折合成天数:三天折合一年,一天折合四个月,一个时辰折合十天,一个小时折合五天,反推得到一年按360天算,一个月按30天算
        var $y = Math.floor($days / 360); //三天折合一年
        var $m = Math.floor($days % 360 / 30); //一天折合四个月
        var $d = Math.floor($days % 360 % 30); //一个小时折合五天



        $ret['begtime'] = this.formatDate("", $begTime);
        $ret['bazi'] = "";


        for (var $j = 0; $j <= 3; $j++) {


            $ret['bazi'] += this.ctg[$tg[$j]];
            $ret['bazi'] += this.cdz[$dz[$j]];
        }

        $ret['tg'] = $tg;
        $ret['dz'] = $dz;
        $ret['big_info'] = $big_info;
        $ret['before_info'] = $before_info;
        $ret['start_desc'] = $y + "年" + $m + "月" + $d + "天后起运";

        return $ret;
    },

    /**
     * 高氏公式
     * 可以计算任意一天的 干支
     */
    monthBaseData: [0, 31, -1, 30, 0, 31, 1, 32, 3, 33, 4, 34],

    jiazhi: [
        "甲子", "乙丑", "丙寅", "丁卯", "戊辰", "己巳", "庚午", "辛未", "壬申", "癸酉",
        "甲戌", "乙亥", "丙子", "丁丑", "戊寅", "己卯", "庚辰", "辛巳", "壬午", "癸未",
        "甲申", "乙酉", "丙戌", "丁亥", "戊子", "己丑", "庚寅", "辛卯", "壬辰", "癸巳",
        "甲午", "乙未", "丙申", "丁酉", "戊戌", "己亥", "庚子", "辛丑", "壬寅", "癸卯",
        "甲辰", "乙巳", "丙午", "丁未", "戊申", "己酉", "庚戌", "辛亥", "壬子", "癸丑",
        "甲寅", "乙卯", "丙辰", "丁巳", "戊午", "己未", "庚申", "辛酉", "壬戌", "癸亥"
    ],

    getCenturyData: function ($year) {
        var $c, $x
        $c = $year / 100 + 1;
        $c = Math.floor($c);
        $x = 44 * ($c - 17) + ($c - 17) / 4 + 3;
        $x = Math.floor($x);
        $x = $x % 60;

        return $x;

    },

    /**
     * 得到日支干支
     * @param calendar
     * @return
     */
    getRizhuIndex: function ($utime) {

        //$utime=613432800;
        var $year, $d, $m, $x, $s, $u, $st, $r, $u;

        var $ymd  = this.formatDate("ymd",$utime);
        // var $date = new Date($ymd.y+"/"+$ymd.m+"/"+$ymd.d);
        // $utime  =   ($date.getTime())/1000;
        // var $date = $ymd.y + '-' + ($ymd.m < 10 ? '0' + $ymd.m : $ymd.m) + '-' + ($ymd.d < 10 ? '0' + $ymd.d : $ymd.d);
        // $utime = MOMENT_TIME.getUnixTimeByTimeStr($date);

        $utime = this.Solar2Julian($ymd.y, $ymd.m, $ymd.d);

        // var $date2 = new Date("2019/09/24");
        // var $utime2  =   ($date2.getTime())/1000;
        // var $date2 = '2019-09-24';
        // var $utime2 = MOMENT_TIME.getUnixTimeByTimeStr($date2);

        // var diff    =   $utime-$utime2;

        // var $chaday =   parseInt(diff/86400);
        // $r      =   $chaday%60;

        var $jd = Math.floor($utime + 0.5);
        var $chaday = ($jd - 2444951);
        // $chaday = Math.ceil($chaday);
        $r = $chaday % 60;

        if ($r < 0) {
            $r += 60;
        }
        var $arr = this.jiazhi[$r].split("");

        var tmp = [];
        tmp['g'] = this.getGanPosition($arr[0]);
        tmp['z'] = this.getZhiPosition($arr[1]);
        tmp['msg'] = this.jiazhi[$r];
        return tmp;


    },

    isRunnian: function ($year) {

        if ($year % 100 == 0) {
            return $year % 400 == 0;
        } else {
            return $year % 4 == 0;
        }

    },

    /**
     * 返回输入的地支所对应的位置
     *
     * @param gan
     * @return
     */
    getGanPosition: function ($str) {
        // 返回输入的天干所对应的位置
        var allstr = this.ctg.join("");

        return allstr.indexOf($str);
    },

    getZhiPosition: function ($str) {// 返回输入的天干所对应的位置

        var allstr = this.cdz.join("");

        return allstr.indexOf($str);

    },

    /**
     * 输入年份天干，返回该年中的十二个月
     *
     * @param mGan
     * @return
     */
    getLiuNianSLiuYue: function ($yGan) {
        var $gan, $zhi, $tmp, $i, $tg, $dz, $monBeginGan, $monthGan;

        //getLiuNianSLiuYue
        // 创建当年的所有月的干支字符数组monthGanZhis

        $monthGan = [2, 4, 6, 8, 0];
        //$monthGan = "丙戊庚壬甲";
        // 获得的位置对5求余来源于：甲己对应丙，乙庚对应戊，丙辛对应庚，丁壬对应壬，戊癸对应甲，以此类推
        $monBeginGan = ($yGan % 5);
        $gan = $monthGan[$monBeginGan];
        $zhi = 2;
        $tmp = [];
        for ($i = 0; $i < 12; $i++) {

            $tg = ($gan++) % 10;
            $dz = ($zhi++) % 12;
            var tmp2 = [];
            tmp2['g'] = $tg;
            tmp2['z'] = $dz;
            tmp2['msg'] = this.ctg[$tg]+this.cdz[$dz];
            $tmp[$tmp.length] = tmp2;


        }
        return $tmp;
    },

    getLiuNian: function ($yy) {
        $yy =   Math.floor($yy);
        var tmp =   [];
        var $ygz = (($yy + 4712 + 24) % 60 + 60)%60;
        var g=  $ygz % 10;
        var z=  $ygz % 12;

        for(var i=0;i<10;i++){
            var tmp2    =   {};
            tmp2.g = (g+i) % 10; //年干
            tmp2.z = (z+i) % 12; //年支
            tmp2.y =  $yy+i;
            tmp2.g_str = this.ctg[tmp2.g];
            tmp2.z_str = this.cdz[tmp2.z];

            tmp[tmp.length] =   tmp2;
        }
        return tmp;

    },
    getLiuYueNew: function($yy) {
        $yy =   Math.floor($yy);
        var $jq = [], $jqList = [], all = [],
            $jq1 = this.GetAdjustedJQ($yy-1),
            $jq2 = this.GetAdjustedJQ($yy);
        $jq1 = $jq1.splice(21, 5);
        $jq2 = $jq2.splice(2, 19);
        $jq = $jq1.concat($jq2);
        // 处理二十四节气
        for(var i = 0; i < 24; i++) {
            var temp = this.setFromJD($jq[i]);
            $jqList.push(temp);
        }
        var $ygz = (($yy + 4712 + 24) % 60 + 60)%60;
        var yg=  $ygz % 10;
        var yArr    =   this.getLiuNianSLiuYue(yg);
        for(var j = 0; j < 12; j++) {
            var k1 = j*2+0, k2 = j*2+1;
            var tmp = yArr[j],
                tmp1 = $jqList[k1],
                tmp2 = $jqList[k2];
            tmp.gan = this.ctg[tmp.g];
            tmp.zhi = this.cdz[tmp.z];
            tmp.jieqi = [];
            tmp.jieqi[0] = {'name': this.jqall[k1], 'time': tmp1};
            tmp.jieqi[1] = {'name': this.jqall[k2], 'time': tmp2};
            all[j] = tmp;
        }
        // console.error('getLiuYueNew----', all)
        return all;
    },

    getLiuYue: function ($yy) {
        $yy =   Math.floor($yy);
        var $y  =   this.GetPureJQsinceSpring($yy);
        var all =   [];

        var $ygz = (($yy + 4712 + 24) % 60 + 60)%60;
        var yg=  $ygz % 10;

        var yArr    =   this.getLiuNianSLiuYue(yg);

        for(var i=1;i<13;i++) {
            var tmp =   yArr[all.length];
            var tmp2=   this.setFromJD($y[i]);
            tmp.m   =   tmp2[1];
            tmp.d   =   tmp2[2];
            tmp.y   =   tmp2[0];
            // var date = new Date(tmp.y+"/"+tmp.m+"/"+tmp.d+" 00:00:00"); //0:1170518400000
            // tmp.begtime =   date.getTime();
            var $$y, $$m, $$d, $$h, $$i, $$s;
            $$y = this.formatYearNum(tmp2[0]);
            $$m = UTILS.getTimeStrByInt(tmp2[1]);
            $$d = UTILS.getTimeStrByInt(tmp2[2]);
            $$h = UTILS.getTimeStrByInt(tmp2[3]);
            $$i = UTILS.getTimeStrByInt(tmp2[4]);
            $$s = UTILS.getTimeStrByInt(tmp2[5]);
            var date = $$y  + '-' + $$m + '-' + $$d + ' ' + $$h + ':' + $$i + ':' + $$s;
            tmp.begtime = MOMENT_TIME.getUnixTimeByTimeStr(date) * 1000;
            var tmp3 =  this.setFromJD($y[i+1]);
            // var date2= new Date(tmp3[0]+"/"+tmp3[1]+"/"+tmp3[2]+" 00:00:00"); //0:1173110400000
            // tmp.endtime =   date2.getTime();
            var $$$y, $$$m, $$$d, $$$h, $$$i, $$$s;
            $$$y = this.formatYearNum(tmp3[0]);
            $$$m = UTILS.getTimeStrByInt(tmp3[1]);
            $$$d = UTILS.getTimeStrByInt(tmp3[2]);
            $$$h = UTILS.getTimeStrByInt(tmp3[3]);
            $$$i = UTILS.getTimeStrByInt(tmp3[4]);
            $$$s = UTILS.getTimeStrByInt(tmp3[5]);
            var date2 = $$$y  + '-' + $$$m + '-' + $$$d + ' ' + $$$h + ':' + $$$i + ':' + $$$s;
            tmp.endtime = MOMENT_TIME.getUnixTimeByTimeStr(date2) * 1000;

            all[all.length]   = tmp;
        }
        // console.error('getLiuYue--------', all)
        return all;
    },

    getLiuRi: function ($beg,$end) {
        $beg =   Math.floor($beg);
        $end =   Math.floor($end);

        var day=[];
        var z=0;

        var $dtime  =   $beg/1000;

        $dtime  =   Math.floor($dtime);

        var $ri = this.getRizhuIndex($dtime);
        var $h  =  this.formatDate("H",$beg,false);
        if($h<10){
            $beg+=7200000;//万恶的中国有夏令时，导致某些天只有23个小时 或者某些天有25个小时， 当有25个小时的时候+86400000的时候没有加1天
        }

        for(var $i = $beg; $i < $end; $i = $i+86400000){


            var tmp =   this.formatDate("ymdhis",$i,false);
            tmp.g   =   ($ri['g']+z)%10;
            tmp.z   =   ($ri['z']+z)%12;

            tmp.msg  =  this.ctg[tmp.g]+this.cdz[tmp.z];
            day[day.length] =   tmp;

            z++;

        }
        // console.error('getLiuRi------', day)
        return day;

    },

    /**
     * 输入日干，返回每天十二个时辰 分早晚子时
     *
     * @param rGan
     * @return
     */
    getLiuRISLiuShi: function ($Gan) {

        var $gan, $zhi, $tmp, $i, $tg, $dz, $GanArr, $BeginGan, $start, $end;

        $GanArr = [0, 2, 4, 6, 8];
        //$monthGan = "丙戊庚壬甲";
        // 获得的位置对5求余来源于：甲己对应丙，乙庚对应戊，丙辛对应庚，丁壬对应壬，戊癸对应甲，以此类推
        $BeginGan = ($Gan % 5);
        $gan = $GanArr[$BeginGan];
        $zhi = 0;

        $tmp = [];

        for ($i = 0; $i < 13; $i++) {

            $tg = ($gan++) % 10;

            $dz = ($zhi++) % 12;


            $start = 2 * $i - 1;

            $end = 2 * $i + 1;

            if ($start == -1) {
                $start = 0;
            }

            if ($end == 25) {
                $end = 24;
            }


            var tmp2 = [];
            tmp2['g'] = $tg;
            tmp2['z'] = $dz;
            tmp2['msg'] = this.ctg[$tg] + this.cdz[$dz];
            tmp2['beg'] = $start;
            tmp2['end'] = $end;

            $tmp[$tmp.length] = tmp2;

        }

        return $tmp;
    },

    //--------------------
    //节气

    nutB: [// 章动表
        2.1824391966, -33.757045954, 0.0000362262, 3.7340E-08, -2.8793E-10,
        -171996, -1742, 92025, 89, 3.5069406862, 1256.663930738,
        0.0000105845, 6.9813E-10, -2.2815E-10, -13187, -16, 5736, -31,
        1.3375032491, 16799.418221925, -0.0000511866, 6.4626E-08,
        -5.3543E-10, -2274, -2, 977, -5, 4.3648783932, -67.514091907,
        0.0000724525, 7.4681E-08, -5.7586E-10, 2062, 2, -895, 5,
        0.0431251803, -628.301955171, 0.0000026820, 6.5935E-10, 5.5705E-11,
        -1426, 34, 54, -1, 2.3555557435, 8328.691425719, 0.0001545547,
        2.5033E-07, -1.1863E-09, 712, 1, -7, 0, 3.4638155059,
        1884.965885909, 0.0000079025, 3.8785E-11, -2.8386E-10, -517, 12,
        224, -6, 5.4382493597, 16833.175267879, -0.0000874129, 2.7285E-08,
        -2.4750E-10, -386, -4, 200, 0, 3.6930589926, 25128.109647645,
        0.0001033681, 3.1496E-07, -1.7218E-09, -301, 0, 129, -1,
        3.5500658664, 628.361975567, 0.0000132664, 1.3575E-09, -1.7245E-10,
        217, -5, -95, 3],

    dts: [
        // 世界时与原子时之差计算表
        -4000, 108371.7, -13036.80, 392.000, 0.0000, -500, 17201.0,
        -627.82, 16.170, -0.3413, -150, 12200.6, -346.41, 5.403, -0.1593,
        150, 9113.8, -328.13, -1.647, 0.0377, 500, 5707.5, -391.41, 0.915,
        0.3145, 900, 2203.4, -283.45, 13.034, -0.1778, 1300, 490.1, -57.35,
        2.085, -0.0072, 1600, 120.0, -9.81, -1.532, 0.1403, 1700, 10.2,
        -0.91, 0.510, -0.0370, 1800, 13.4, -0.72, 0.202, -0.0193, 1830,
        7.8, -1.81, 0.416, -0.0247, 1860, 8.3, -0.13, -0.406, 0.0292, 1880,
        -5.4, 0.32, -0.183, 0.0173, 1900, -2.3, 2.06, 0.169, -0.0135, 1920,
        21.2, 1.69, -0.304, 0.0167, 1940, 24.2, 1.22, -0.064, 0.0031, 1960,
        33.2, 0.51, 0.231, -0.0109, 1980, 51.0, 1.29, -0.026, 0.0032, 2000,
        64.7, -1.66, 5.224, -0.2905, 2150, 279.4, 732.95, 429.579, 0.0158,
        6000],

    rad: 180 * 3600 / Math.PI,     // 每弧度的角秒数
    J2000: 2451545.0,   // 2000年前儒略日数(2000-1-1

    GXC_e: [0.016708634, -0.000042037, -0.0000001267], // 离心率

    GXC_p: [102.93735 / (180 / Math.PI), 1.71946 / (180 / Math.PI), 0.00046 / (180 / Math.PI)], // 近点

    GXC_l: [
        280.4664567 / (180 / Math.PI),
        36000.76982779 / (180 / Math.PI),
        0.0003032028 / (180 / Math.PI),
        0.0,
        0.0], // 太平黄经
    GXC_k: 20.49552 / (180 * 3600 / Math.PI), // 光行差常数


    // ==================日位置计算===================
    EnnT: 0, // 调用Enn前先设置EnnT时间变量
    // ==================月位置计算===================
    MnnT: 0, // 调用Mnn前先设置MnnT时间变量

    /***************************************
     * 如果用记事本查看此代码,请在"格式"菜单中去除"自动换行"
     * E10是关于地球的,格式如下:
     *    它是一个数组,每3个数看作一条记录,每条记录的3个数记为A,B,C
     *    rec=A*Math.cos(B+C*t);  式中t是J2000起算的儒略千年数
     *    每条记录的计算结果(即rec)取和即得地球的日心黄经的周期量L0
     * E11格式如下: rec = A*Math.cos*(B+C*t) *t,     取和后得泊松量L1
     * E12格式如下: rec = A*Math.cos*(B+C*t) *t*t,   取和后得泊松量L2
     * E13格式如下: rec = A*Math.cos*(B+C*t) *t*t*t, 取和后得泊松量L3
     * 最后地球的地心黄经:L = L0+L1+L2+L3+...
     * E20,E21,E22,E23...用于计算黄纬
     * M10,M11等是关于月球的,参数的用法请阅读Mnn()函数
     *****************************************/
    //地球运动VSOP87参数
    E10: [ //黄经周期项
        1.75347045673, 0.00000000000, 0.0000000000, 0.03341656456, 4.66925680417, 6283.0758499914, 0.00034894275, 4.62610241759, 12566.1516999828, 0.00003417571, 2.82886579606, 3.5231183490,
        0.00003497056, 2.74411800971, 5753.3848848968, 0.00003135896, 3.62767041758, 77713.7714681205, 0.00002676218, 4.41808351397, 7860.4193924392, 0.00002342687, 6.13516237631, 3930.2096962196,
        0.00001273166, 2.03709655772, 529.6909650946, 0.00001324292, 0.74246356352, 11506.7697697936, 0.00000901855, 2.04505443513, 26.2983197998, 0.00001199167, 1.10962944315, 1577.3435424478,
        0.00000857223, 3.50849156957, 398.1490034082, 0.00000779786, 1.17882652114, 5223.6939198022, 0.00000990250, 5.23268129594, 5884.9268465832, 0.00000753141, 2.53339053818, 5507.5532386674,
        0.00000505264, 4.58292563052, 18849.2275499742, 0.00000492379, 4.20506639861, 775.5226113240, 0.00000356655, 2.91954116867, 0.0673103028, 0.00000284125, 1.89869034186, 796.2980068164,
        0.00000242810, 0.34481140906, 5486.7778431750, 0.00000317087, 5.84901952218, 11790.6290886588, 0.00000271039, 0.31488607649, 10977.0788046990, 0.00000206160, 4.80646606059, 2544.3144198834,
        0.00000205385, 1.86947813692, 5573.1428014331, 0.00000202261, 2.45767795458, 6069.7767545534, 0.00000126184, 1.08302630210, 20.7753954924, 0.00000155516, 0.83306073807, 213.2990954380,
        0.00000115132, 0.64544911683, 0.9803210682, 0.00000102851, 0.63599846727, 4694.0029547076, 0.00000101724, 4.26679821365, 7.1135470008, 0.00000099206, 6.20992940258, 2146.1654164752,
        0.00000132212, 3.41118275555, 2942.4634232916, 0.00000097607, 0.68101272270, 155.4203994342, 0.00000085128, 1.29870743025, 6275.9623029906, 0.00000074651, 1.75508916159, 5088.6288397668,
        0.00000101895, 0.97569221824, 15720.8387848784, 0.00000084711, 3.67080093025, 71430.6956181291, 0.00000073547, 4.67926565481, 801.8209311238, 0.00000073874, 3.50319443167, 3154.6870848956,
        0.00000078756, 3.03698313141, 12036.4607348882, 0.00000079637, 1.80791330700, 17260.1546546904, 0.00000085803, 5.98322631256, 161000.6857376741, 0.00000056963, 2.78430398043, 6286.5989683404,
        0.00000061148, 1.81839811024, 7084.8967811152, 0.00000069627, 0.83297596966, 9437.7629348870, 0.00000056116, 4.38694880779, 14143.4952424306, 0.00000062449, 3.97763880587, 8827.3902698748,
        0.00000051145, 0.28306864501, 5856.4776591154, 0.00000055577, 3.47006009062, 6279.5527316424, 0.00000041036, 5.36817351402, 8429.2412664666, 0.00000051605, 1.33282746983, 1748.0164130670,
        0.00000051992, 0.18914945834, 12139.5535091068, 0.00000049000, 0.48735065033, 1194.4470102246, 0.00000039200, 6.16832995016, 10447.3878396044, 0.00000035566, 1.77597314691, 6812.7668150860,
        0.00000036770, 6.04133859347, 10213.2855462110, 0.00000036596, 2.56955238628, 1059.3819301892, 0.00000033291, 0.59309499459, 17789.8456197850, 0.00000035954, 1.70876111898, 2352.8661537718],

    E11: [ //黄经泊松1项
        6283.31966747491, 0.00000000000, 0.0000000000, 0.00206058863, 2.67823455584, 6283.0758499914, 0.00004303430, 2.63512650414, 12566.1516999828, 0.00000425264, 1.59046980729, 3.5231183490,
        0.00000108977, 2.96618001993, 1577.3435424478, 0.00000093478, 2.59212835365, 18849.2275499742, 0.00000119261, 5.79557487799, 26.2983197998, 0.00000072122, 1.13846158196, 529.6909650946,
        0.00000067768, 1.87472304791, 398.1490034082, 0.00000067327, 4.40918235168, 5507.5532386674, 0.00000059027, 2.88797038460, 5223.6939198022, 0.00000055976, 2.17471680261, 155.4203994342,
        0.00000045407, 0.39803079805, 796.2980068164, 0.00000036369, 0.46624739835, 775.5226113240, 0.00000028958, 2.64707383882, 7.1135470008, 0.00000019097, 1.84628332577, 5486.7778431750,
        0.00000020844, 5.34138275149, 0.9803210682, 0.00000018508, 4.96855124577, 213.2990954380, 0.00000016233, 0.03216483047, 2544.3144198834, 0.00000017293, 2.99116864949, 6275.9623029906],

    E12: [ //黄经泊松2项
        0.00052918870, 0.00000000000, 0.0000000000, 0.00008719837, 1.07209665242, 6283.0758499914, 0.00000309125, 0.86728818832, 12566.1516999828, 0.00000027339, 0.05297871691, 3.5231183490,
        0.00000016334, 5.18826691036, 26.2983197998, 0.00000015752, 3.68457889430, 155.4203994342, 0.00000009541, 0.75742297675, 18849.2275499742, 0.00000008937, 2.05705419118, 77713.7714681205,
        0.00000006952, 0.82673305410, 775.5226113240, 0.00000005064, 4.66284525271, 1577.3435424478],
    E13: [0.00000289226, 5.84384198723, 6283.0758499914, 0.00000034955, 0.00000000000, 0.0000000000, 0.00000016819, 5.48766912348, 12566.1516999828],
    E14: [0.00000114084, 3.14159265359, 0.0000000000, 0.00000007717, 4.13446589358, 6283.0758499914, 0.00000000765, 3.83803776214, 12566.1516999828],

    E15: [0.00000000878, 3.14159265359, 0.0000000000],
    E20: [  //黄纬周期项
        0.00000279620, 3.19870156017, 84334.6615813083, 0.00000101643, 5.42248619256, 5507.5532386674, 0.00000080445, 3.88013204458, 5223.6939198022, 0.00000043806, 3.70444689758, 2352.8661537718,
        0.00000031933, 4.00026369781, 1577.3435424478, 0.00000022724, 3.98473831560, 1047.7473117547, 0.00000016392, 3.56456119782, 5856.4776591154, 0.00000018141, 4.98367470263, 6283.0758499914,
        0.00000014443, 3.70275614914, 9437.7629348870, 0.00000014304, 3.41117857525, 10213.2855462110],
    E21: [0.00000009030, 3.89729061890, 5507.5532386674, 0.00000006177, 1.73038850355, 5223.6939198022],
    E30: [  //距离周期项
        1.00013988799, 0.00000000000, 0.0000000000, 0.01670699626, 3.09846350771, 6283.0758499914, 0.00013956023, 3.05524609620, 12566.1516999828, 0.00003083720, 5.19846674381, 77713.7714681205,
        0.00001628461, 1.17387749012, 5753.3848848968, 0.00001575568, 2.84685245825, 7860.4193924392, 0.00000924799, 5.45292234084, 11506.7697697936, 0.00000542444, 4.56409149777, 3930.2096962196],
    E31: [0.00103018608, 1.10748969588, 6283.0758499914, 0.00001721238, 1.06442301418, 12566.1516999828, 0.00000702215, 3.14159265359, 0.0000000000],
    E32: [0.00004359385, 5.78455133738, 6283.0758499914],
    E33: [0.00000144595, 4.27319435148, 6283.0758499914],


    //月球运动参数
    M10: [
        22639.5858800, 2.3555545723, 8328.6914247251, 1.5231275E-04, 2.5041111E-07, -1.1863391E-09, 4586.4383203, 8.0413790709, 7214.0628654588, -2.1850087E-04, -1.8646419E-07, 8.7760973E-10, 2369.9139357, 10.3969336431, 15542.7542901840, -6.6188121E-05, 6.3946925E-08, -3.0872935E-10, 769.0257187, 4.7111091445, 16657.3828494503, 3.0462550E-04, 5.0082223E-07, -2.3726782E-09,
        -666.4175399, -0.0431256817, 628.3019552485, -2.6638815E-06, 6.1639211E-10, -5.4439728E-11, -411.5957339, 3.2558104895, 16866.9323152810, -1.2804259E-04, -9.8998954E-09, 4.0433461E-11, 211.6555524, 5.6858244986, -1114.6285592663, -3.7081362E-04, -4.3687530E-07, 2.0639488E-09, 205.4359530, 8.0845047526, 6585.7609102104, -2.1583699E-04, -1.8708058E-07, 9.3204945E-10,
        191.9561973, 12.7524882154, 23871.4457149091, 8.6124629E-05, 3.1435804E-07, -1.4950684E-09, 164.7286185, 10.4400593249, 14914.4523349355, -6.3524240E-05, 6.3330532E-08, -2.5428962E-10, -147.3213842, -2.3986802540, -7700.3894694766, -1.5497663E-04, -2.4979472E-07, 1.1318993E-09, -124.9881185, 5.1984668216, 7771.3771450920, -3.3094061E-05, 3.1973462E-08, -1.5436468E-10,
        -109.3803637, 2.3124288905, 8956.9933799736, 1.4964887E-04, 2.5102751E-07, -1.2407788E-09, 55.1770578, 7.1411231536, -1324.1780250970, 6.1854469E-05, 7.3846820E-08, -3.4916281E-10, -45.0996092, 5.6113650618, 25195.6237400061, 2.4270161E-05, 2.4051122E-07, -1.1459056E-09, 39.5333010, -0.9002559173, -8538.2408905558, 2.8035534E-04, 2.6031101E-07, -1.2267725E-09,
        38.4298346, 18.4383127140, 22756.8171556428, -2.8468899E-04, -1.2251727E-07, 5.6888037E-10, 36.1238141, 7.0666637168, 24986.0742741754, 4.5693825E-04, 7.5123334E-07, -3.5590172E-09, 30.7725751, 16.0827581417, 14428.1257309177, -4.3700174E-04, -3.7292838E-07, 1.7552195E-09, -28.3971008, 7.9982533891, 7842.3648207073, -2.2116475E-04, -1.8584780E-07, 8.2317000E-10,
        -24.3582283, 10.3538079614, 16171.0562454324, -6.8852003E-05, 6.4563317E-08, -3.6316908E-10, -18.5847068, 2.8429122493, -557.3142796331, -1.8540681E-04, -2.1843765E-07, 1.0319744E-09, 17.9544674, 5.1553411398, 8399.6791003405, -3.5757942E-05, 3.2589854E-08, -2.0880440E-10, 14.5302779, 12.7956138971, 23243.1437596606, 8.8788511E-05, 3.1374165E-07, -1.4406287E-09,
        14.3796974, 15.1080427876, 32200.1371396342, 2.3843738E-04, 5.6476915E-07, -2.6814075E-09, 14.2514576, -24.0810366320, -2.3011998397, 1.5231275E-04, 2.5041111E-07, -1.1863391E-09, 13.8990596, 20.7938672862, 31085.5085803679, -1.3237624E-04, 1.2789385E-07, -6.1745870E-10, 13.1940636, 3.3302699264, -9443.3199839914, -5.2312637E-04, -6.8728642E-07, 3.2502879E-09,
        -9.6790568, -4.7542348263, -16029.0808942018, -3.0728938E-04, -5.0020584E-07, 2.3182384E-09, -9.3658635, 11.2971895604, 24080.9951807398, -3.4654346E-04, -1.9636409E-07, 9.1804319E-10, 8.6055318, 5.7289501804, -1742.9305145148, -3.6814974E-04, -4.3749170E-07, 2.1183885E-09, -8.4530982, 7.5540213938, 16100.0685698171, 1.1921869E-04, 2.8238458E-07, -1.3407038E-09,
        8.0501724, 10.4831850066, 14286.1503796870, -6.0860358E-05, 6.2714140E-08, -1.9984990E-10, -7.6301553, 4.6679834628, 17285.6848046987, 3.0196162E-04, 5.0143862E-07, -2.4271179E-09, -7.4474952, -0.0862513635, 1256.6039104970, -5.3277630E-06, 1.2327842E-09, -1.0887946E-10, 7.3712011, 8.1276304344, 5957.4589549619, -2.1317311E-04, -1.8769697E-07, 9.8648918E-10,
        7.0629900, 0.9591375719, 33.7570471374, -3.0829302E-05, -3.6967043E-08, 1.7385419E-10, -6.3831491, 9.4966777258, 7004.5133996281, 2.1416722E-04, 3.2425793E-07, -1.5355019E-09, -5.7416071, 13.6527441326, 32409.6866054649, -1.9423071E-04, 5.4047029E-08, -2.6829589E-10, 4.3740095, 18.4814383957, 22128.5152003943, -2.8202511E-04, -1.2313366E-07, 6.2332010E-10,
        -3.9976134, 7.9669196340, 33524.3151647312, 1.7658291E-04, 4.9092233E-07, -2.3322447E-09, -3.2096876, 13.2398458924, 14985.4400105508, -2.5159493E-04, -1.5449073E-07, 7.2324505E-10, -2.9145404, 12.7093625336, 24499.7476701576, 8.3460748E-05, 3.1497443E-07, -1.5495082E-09, 2.7318890, 16.1258838235, 13799.8237756692, -4.3433786E-04, -3.7354477E-07, 1.8096592E-09,
        -2.5679459, -2.4418059357, -7072.0875142282, -1.5764051E-04, -2.4917833E-07, 1.0774596E-09, -2.5211990, 7.9551277074, 8470.6667759558, -2.2382863E-04, -1.8523141E-07, 7.6873027E-10, 2.4888871, 5.6426988169, -486.3266040178, -3.7347750E-04, -4.3625891E-07, 2.0095091E-09, 2.1460741, 7.1842488353, -1952.4799803455, 6.4518350E-05, 7.3230428E-08, -2.9472308E-10,
        1.9777270, 23.1494218585, 39414.2000050930, 1.9936508E-05, 3.7830496E-07, -1.8037978E-09, 1.9336825, 9.4222182890, 33314.7656989005, 6.0925100E-04, 1.0016445E-06, -4.7453563E-09, 1.8707647, 20.8369929680, 30457.2066251194, -1.2971236E-04, 1.2727746E-07, -5.6301898E-10, -1.7529659, 0.4873576771, -8886.0057043583, -3.3771956E-04, -4.6884877E-07, 2.2183135E-09,
        -1.4371624, 7.0979974718, -695.8760698485, 5.9190587E-05, 7.4463212E-08, -4.0360254E-10, -1.3725701, 1.4552986550, -209.5494658307, 4.3266809E-04, 5.1072212E-07, -2.4131116E-09, 1.2618162, 7.5108957121, 16728.3705250656, 1.1655481E-04, 2.8300097E-07, -1.3951435E-09],
    M11: [
        1.6768000, -0.0431256817, 628.3019552485, -2.6638815E-06, 6.1639211E-10, -5.4439728E-11, 0.5164200, 11.2260974062, 6585.7609102104, -2.1583699E-04, -1.8708058E-07, 9.3204945E-10, 0.4138300, 13.5816519784, 14914.4523349355, -6.3524240E-05, 6.3330532E-08, -2.5428962E-10, 0.3711500, 5.5402729076, 7700.3894694766, 1.5497663E-04, 2.4979472E-07, -1.1318993E-09,
        0.2756000, 2.3124288905, 8956.9933799736, 1.4964887E-04, 2.5102751E-07, -1.2407788E-09, 0.2459863, -25.6198212459, -2.3011998397, 1.5231275E-04, 2.5041111E-07, -1.1863391E-09, 0.0711800, 7.9982533891, 7842.3648207073, -2.2116475E-04, -1.8584780E-07, 8.2317000E-10, 0.0612800, 10.3538079614, 16171.0562454324, -6.8852003E-05, 6.4563317E-08, -3.6316908E-10],
    M12: [0.0048700, -0.0431256817, 628.3019552485, -2.6638815E-06, 6.1639211E-10, -5.4439728E-11, 0.0022800, -27.1705318325, -2.3011998397, 1.5231275E-04, 2.5041111E-07, -1.1863391E-09, 0.0015000, 11.2260974062, 6585.7609102104, -2.1583699E-04, -1.8708058E-07, 9.3204945E-10],
    M20: [
        18461.2400600, 1.6279052448, 8433.4661576405, -6.4021295E-05, -4.9499477E-09, 2.0216731E-11, 1010.1671484, 3.9834598170, 16762.1575823656, 8.8291456E-05, 2.4546117E-07, -1.1661223E-09, 999.6936555, 0.7276493275, -104.7747329154, 2.1633405E-04, 2.5536106E-07, -1.2065558E-09, 623.6524746, 8.7690283983, 7109.2881325435, -2.1668263E-06, 6.8896872E-08, -3.2894608E-10,
        199.4837596, 9.6692843156, 15647.5290230993, -2.8252217E-04, -1.9141414E-07, 8.9782646E-10, 166.5741153, 6.4134738261, -1219.4032921817, -1.5447958E-04, -1.8151424E-07, 8.5739300E-10, 117.2606951, 12.0248388879, 23976.2204478244, -1.3020942E-04, 5.8996977E-08, -2.8851262E-10, 61.9119504, 6.3390143893, 25090.8490070907, 2.4060421E-04, 4.9587228E-07, -2.3524614E-09,
        33.3572027, 11.1245829706, 15437.9795572686, 1.5014592E-04, 3.1930799E-07, -1.5152852E-09, 31.7596709, 3.0832038997, 8223.9166918098, 3.6864680E-04, 5.0577218E-07, -2.3928949E-09, 29.5766003, 8.8121540801, 6480.9861772950, 4.9705523E-07, 6.8280480E-08, -2.7450635E-10, 15.5662654, 4.0579192538, -9548.0947169068, -3.0679233E-04, -4.3192536E-07, 2.0437321E-09,
        15.1215543, 14.3803934601, 32304.9118725496, 2.2103334E-05, 3.0940809E-07, -1.4748517E-09, -12.0941511, 8.7259027166, 7737.5900877920, -4.8307078E-06, 6.9513264E-08, -3.8338581E-10, 8.8681426, 9.7124099974, 15019.2270678508, -2.7985829E-04, -1.9203053E-07, 9.5226618E-10, 8.0450400, 0.6687636586, 8399.7091105030, -3.3191993E-05, 3.2017096E-08, -1.5363746E-10,
        7.9585542, 12.0679645696, 23347.9184925760, -1.2754553E-04, 5.8380585E-08, -2.3407289E-10, 7.4345550, 6.4565995078, -1847.7052474301, -1.5181570E-04, -1.8213063E-07, 9.1183272E-10, -6.7314363, -4.0265854988, -16133.8556271171, -9.0955337E-05, -2.4484477E-07, 1.1116826E-09, 6.5795750, 16.8104074692, 14323.3509980023, -2.2066770E-04, -1.1756732E-07, 5.4866364E-10,
        -6.4600721, 1.5847795630, 9061.7681128890, -6.6685176E-05, -4.3335556E-09, -3.4222998E-11, -6.2964773, 4.8837157343, 25300.3984729215, -1.9206388E-04, -1.4849843E-08, 6.0650192E-11, -5.6323538, -0.7707750092, 733.0766881638, -2.1899793E-04, -2.5474467E-07, 1.1521161E-09, -5.3683961, 6.8263720663, 16204.8433027325, -9.7115356E-05, 2.7023515E-08, -1.3414795E-10,
        -5.3112784, 3.9403341353, 17390.4595376141, 8.5627574E-05, 2.4607756E-07, -1.2205621E-09, -5.0759179, 0.6845236457, 523.5272223331, 2.1367016E-04, 2.5597745E-07, -1.2609955E-09, -4.8396143, -1.6710309265, -7805.1642023920, 6.1357413E-05, 5.5663398E-09, -7.4656459E-11, -4.8057401, 3.5705615768, -662.0890125485, 3.0927234E-05, 3.6923410E-08, -1.7458141E-10,
        3.9840545, 8.6945689615, 33419.5404318159, 3.9291696E-04, 7.4628340E-07, -3.5388005E-09, 3.6744619, 19.1659620415, 22652.0424227274, -6.8354947E-05, 1.3284380E-07, -6.3767543E-10, 2.9984815, 20.0662179587, 31190.2833132833, -3.4871029E-04, -1.2746721E-07, 5.8909710E-10, 2.7986413, -2.5281611620, -16971.7070481963, 3.4437664E-04, 2.6526096E-07, -1.2469893E-09,
        2.4138774, 17.7106633865, 22861.5918885581, -5.0102304E-04, -3.7787833E-07, 1.7754362E-09, 2.1863132, 5.5132179088, -9757.6441827375, 1.2587576E-04, 7.8796768E-08, -3.6937954E-10, 2.1461692, 13.4801375428, 23766.6709819937, 3.0245868E-04, 5.6971910E-07, -2.7016242E-09, 1.7659832, 11.1677086523, 14809.6776020201, 1.5280981E-04, 3.1869159E-07, -1.4608454E-09,
        -1.6244212, 7.3137297434, 7318.8375983742, -4.3483492E-04, -4.4182525E-07, 2.0841655E-09, 1.5813036, 5.4387584720, 16552.6081165349, 5.2095955E-04, 7.5618329E-07, -3.5792340E-09, 1.5197528, 16.7359480324, 40633.6032972747, 1.7441609E-04, 5.5981921E-07, -2.6611908E-09, 1.5156341, 1.7023646816, -17876.7861416319, -4.5910508E-04, -6.8233647E-07, 3.2300712E-09,
        1.5102092, 5.4977296450, 8399.6847301375, -3.3094061E-05, 3.1973462E-08, -1.5436468E-10, -1.3178223, 9.6261586339, 16275.8309783478, -2.8518605E-04, -1.9079775E-07, 8.4338673E-10, -1.2642739, 11.9817132061, 24604.5224030729, -1.3287330E-04, 5.9613369E-08, -3.4295235E-10, 1.1918723, 22.4217725310, 39518.9747380084, -1.9639754E-04, 1.2294390E-07, -5.9724197E-10,
        1.1346110, 14.4235191419, 31676.6099173011, 2.4767216E-05, 3.0879170E-07, -1.4204120E-09, 1.0857810, 8.8552797618, 5852.6842220465, 3.1609367E-06, 6.7664088E-08, -2.2006663E-10, -1.0193852, 7.2392703065, 33629.0898976466, -3.9751134E-05, 2.3556127E-07, -1.1256889E-09, -0.8227141, 11.0814572888, 16066.2815125171, 1.4748204E-04, 3.1992438E-07, -1.5697249E-09,
        0.8042238, 3.5274358950, -33.7870573000, 2.8263353E-05, 3.7539802E-08, -2.2902113E-10, 0.8025939, 6.7832463846, 16833.1452579809, -9.9779237E-05, 2.7639907E-08, -1.8858767E-10, -0.7931866, -6.3821400710, -24462.5470518423, -2.4326809E-04, -4.9525589E-07, 2.2980217E-09, -0.7910153, 6.3703481443, -591.1013369332, -1.5714346E-04, -1.8089785E-07, 8.0295327E-10,
        -0.6674056, 9.1819266386, 24533.5347274576, 5.5197395E-05, 2.7743463E-07, -1.3204870E-09, 0.6502226, 4.1010449356, -10176.3966721553, -3.0412845E-04, -4.3254175E-07, 2.0981718E-09, -0.6388131, 6.2958887075, 25719.1509623392, 2.3794032E-04, 4.9648867E-07, -2.4069012E-09],
    M21: [
        0.0743000, 11.9537467337, 6480.9861772950, 4.9705523E-07, 6.8280480E-08, -2.7450635E-10, 0.0304300, 8.7259027166, 7737.5900877920, -4.8307078E-06, 6.9513264E-08, -3.8338581E-10, 0.0222900, 12.8540026510, 15019.2270678508, -2.7985829E-04, -1.9203053E-07, 9.5226618E-10, 0.0199900, 15.2095572232, 23347.9184925760, -1.2754553E-04, 5.8380585E-08, -2.3407289E-10,
        0.0186900, 9.5981921614, -1847.7052474301, -1.5181570E-04, -1.8213063E-07, 9.1183272E-10, 0.0169600, 7.1681781524, 16133.8556271171, 9.0955337E-05, 2.4484477E-07, -1.1116826E-09, 0.0162300, 1.5847795630, 9061.7681128890, -6.6685176E-05, -4.3335556E-09, -3.4222998E-11, 0.0141900, -0.7707750092, 733.0766881638, -2.1899793E-04, -2.5474467E-07, 1.1521161E-09],
    M30: [
        385000.5290396, 1.5707963268, 0.0000000000, 0.0000000E+00, 0.0000000E+00, 0.0000000E+00, -20905.3551378, 3.9263508990, 8328.6914247251, 1.5231275E-04, 2.5041111E-07, -1.1863391E-09, -3699.1109330, 9.6121753977, 7214.0628654588, -2.1850087E-04, -1.8646419E-07, 8.7760973E-10, -2955.9675626, 11.9677299699, 15542.7542901840, -6.6188121E-05, 6.3946925E-08, -3.0872935E-10,
        -569.9251264, 6.2819054713, 16657.3828494503, 3.0462550E-04, 5.0082223E-07, -2.3726782E-09, 246.1584797, 7.2566208254, -1114.6285592663, -3.7081362E-04, -4.3687530E-07, 2.0639488E-09, -204.5861179, 12.0108556517, 14914.4523349355, -6.3524240E-05, 6.3330532E-08, -2.5428962E-10, -170.7330791, 14.3232845422, 23871.4457149091, 8.6124629E-05, 3.1435804E-07, -1.4950684E-09,
        -152.1378118, 9.6553010794, 6585.7609102104, -2.1583699E-04, -1.8708058E-07, 9.3204945E-10, -129.6202242, -0.8278839272, -7700.3894694766, -1.5497663E-04, -2.4979472E-07, 1.1318993E-09, 108.7427014, 6.7692631483, 7771.3771450920, -3.3094061E-05, 3.1973462E-08, -1.5436468E-10, 104.7552944, 3.8832252173, 8956.9933799736, 1.4964887E-04, 2.5102751E-07, -1.2407788E-09,
        79.6605685, 0.6705404095, -8538.2408905558, 2.8035534E-04, 2.6031101E-07, -1.2267725E-09, 48.8883284, 1.5276706450, 628.3019552485, -2.6638815E-06, 6.1639211E-10, -5.4439728E-11, -34.7825237, 20.0091090408, 22756.8171556428, -2.8468899E-04, -1.2251727E-07, 5.6888037E-10, 30.8238599, 11.9246042882, 16171.0562454324, -6.8852003E-05, 6.4563317E-08, -3.6316908E-10,
        24.2084985, 9.5690497159, 7842.3648207073, -2.2116475E-04, -1.8584780E-07, 8.2317000E-10, -23.2104305, 8.6374600436, 24986.0742741754, 4.5693825E-04, 7.5123334E-07, -3.5590172E-09, -21.6363439, 17.6535544685, 14428.1257309177, -4.3700174E-04, -3.7292838E-07, 1.7552195E-09, -16.6747239, 6.7261374666, 8399.6791003405, -3.5757942E-05, 3.2589854E-08, -2.0880440E-10,
        14.4026890, 4.9010662531, -9443.3199839914, -5.2312637E-04, -6.8728642E-07, 3.2502879E-09, -12.8314035, 14.3664102239, 23243.1437596606, 8.8788511E-05, 3.1374165E-07, -1.4406287E-09, -11.6499478, 22.3646636130, 31085.5085803679, -1.3237624E-04, 1.2789385E-07, -6.1745870E-10, -10.4447578, 16.6788391144, 32200.1371396342, 2.3843738E-04, 5.6476915E-07, -2.6814075E-09,
        10.3211071, 8.7119194804, -1324.1780250970, 6.1854469E-05, 7.3846820E-08, -3.4916281E-10, 10.0562033, 7.2997465071, -1742.9305145148, -3.6814974E-04, -4.3749170E-07, 2.1183885E-09, -9.8844667, 12.0539813334, 14286.1503796870, -6.0860358E-05, 6.2714140E-08, -1.9984990E-10, 8.7515625, 6.3563649081, -9652.8694498221, -9.0458282E-05, -1.7656429E-07, 8.3717626E-10,
        -8.3791067, 4.4137085761, -557.3142796331, -1.8540681E-04, -2.1843765E-07, 1.0319744E-09, -7.0026961, -3.1834384995, -16029.0808942018, -3.0728938E-04, -5.0020584E-07, 2.3182384E-09, 6.3220032, 9.1248177206, 16100.0685698171, 1.1921869E-04, 2.8238458E-07, -1.3407038E-09, 5.7508579, 6.2387797896, 17285.6848046987, 3.0196162E-04, 5.0143862E-07, -2.4271179E-09,
        -4.9501349, 9.6984267611, 5957.4589549619, -2.1317311E-04, -1.8769697E-07, 9.8648918E-10, -4.4211770, 3.0260949818, -209.5494658307, 4.3266809E-04, 5.1072212E-07, -2.4131116E-09, 4.1311145, 11.0674740526, 7004.5133996281, 2.1416722E-04, 3.2425793E-07, -1.5355019E-09, -3.9579827, 20.0522347225, 22128.5152003943, -2.8202511E-04, -1.2313366E-07, 6.2332010E-10,
        3.2582371, 14.8106422192, 14985.4400105508, -2.5159493E-04, -1.5449073E-07, 7.2324505E-10, -3.1483020, 4.8266068163, 16866.9323152810, -1.2804259E-04, -9.8998954E-09, 4.0433461E-11, 2.6164092, 14.2801588604, 24499.7476701576, 8.3460748E-05, 3.1497443E-07, -1.5495082E-09, 2.3536310, 9.5259240342, 8470.6667759558, -2.2382863E-04, -1.8523141E-07, 7.6873027E-10,
        -2.1171283, -0.8710096090, -7072.0875142282, -1.5764051E-04, -2.4917833E-07, 1.0774596E-09, -1.8970368, 17.6966801503, 13799.8237756692, -4.3433786E-04, -3.7354477E-07, 1.8096592E-09, -1.7385258, 2.0581540038, -8886.0057043583, -3.3771956E-04, -4.6884877E-07, 2.2183135E-09, -1.5713944, 22.4077892948, 30457.2066251194, -1.2971236E-04, 1.2727746E-07, -5.6301898E-10,
        -1.4225541, 24.7202181853, 39414.2000050930, 1.9936508E-05, 3.7830496E-07, -1.8037978E-09, -1.4189284, 17.1661967915, 23314.1314352759, -9.9282182E-05, 9.5920387E-08, -4.6309403E-10, 1.1655364, 3.8400995356, 9585.2953352221, 1.4698499E-04, 2.5164390E-07, -1.2952185E-09, -1.1169371, 10.9930146158, 33314.7656989005, 6.0925100E-04, 1.0016445E-06, -4.7453563E-09,
        1.0656723, 1.4845449633, 1256.6039104970, -5.3277630E-06, 1.2327842E-09, -1.0887946E-10, 1.0586190, 11.9220903668, 8364.7398411275, -2.1850087E-04, -1.8646419E-07, 8.7760973E-10, -0.9333176, 9.0816920389, 16728.3705250656, 1.1655481E-04, 2.8300097E-07, -1.3951435E-09, 0.8624328, 12.4550876470, 6656.7485858257, -4.0390768E-04, -4.0490184E-07, 1.9095841E-09,
        0.8512404, 4.3705828944, 70.9876756153, -1.8807069E-04, -2.1782126E-07, 9.7753467E-10, -0.8488018, 16.7219647962, 31571.8351843857, 2.4110126E-04, 5.6415276E-07, -2.6269678E-09, -0.7956264, 3.5134526588, -9095.5551701890, 9.4948529E-05, 4.1873358E-08, -1.9479814E-10],
    M31: [
        0.5139500, 12.0108556517, 14914.4523349355, -6.3524240E-05, 6.3330532E-08, -2.5428962E-10, 0.3824500, 9.6553010794, 6585.7609102104, -2.1583699E-04, -1.8708058E-07, 9.3204945E-10, 0.3265400, 3.9694765808, 7700.3894694766, 1.5497663E-04, 2.4979472E-07, -1.1318993E-09, 0.2639600, 0.7416325637, 8956.9933799736, 1.4964887E-04, 2.5102751E-07, -1.2407788E-09,
        0.1230200, -1.6139220085, 628.3019552485, -2.6638815E-06, 6.1639211E-10, -5.4439728E-11, 0.0775400, 8.7830116346, 16171.0562454324, -6.8852003E-05, 6.4563317E-08, -3.6316908E-10, 0.0606800, 6.4274570623, 7842.3648207073, -2.2116475E-04, -1.8584780E-07, 8.2317000E-10, 0.0497000, 12.0539813334, 14286.1503796870, -6.0860358E-05, 6.2714140E-08, -1.9984990E-10],
    M1n: [3.81034392032, 8.39968473021E+03, -3.31919929753E-05, //月球平黄经系数
        3.20170955005E-08, -1.53637455544E-10],


    preceB: [0, 50287.92262, 111.24406, 0.07699, -0.23479, -0.00178, 0.00018, 0.00001],// Date黄道上的岁差p

    yueMing: ["正", "二", "三", "四", "五", "六", "七", "八", "九", "十", "冬", "腊"],


    getJieQi: function ($y, $num = 24) {

        var $jq = [];
        var $i;

        var $t1 = 365.2422 * ($y - 2000); // 农历年首始于前一年的冬至,为了节气中气一起算,取前年大雪之前
        for ($i = 0; $i < $num; $i++) {
            // 计算节气(从冬至开始),注意:返回的是力学时
            $jq[$i] = this.jiaoCal($t1 + $i * 15.22, $i * 15, 0); // 顺便计算节气,它不是农历定朔计算所必需的
            $jq[$i] = $jq[$i] + this.J2000 + 8 / 24; // 计算第i个节气(i=0是春分),结果转为北京时
            var $tmp =  this.setFromJD($jq[$i],true);
            $jq[$i] =   this.Solar2Julian($tmp[0],$tmp[1],$tmp[2],$tmp[3],$tmp[4],$tmp[5]);

        }
        return $jq;

    },

    // ==================已知位置反求时间===================
    jiaoCal: function ($t1, $jiao, $lx) {

        // t1是J2000起算儒略日数
        // 已知角度(jiao)求时间(t)
        // lx=0是太阳黄经达某角度的时刻计算(用于节气计算)
        // lx=1是日月角距达某角度的时刻计算(用于定朔望等)
        // 传入的t1是指定角度对应真时刻t的前一些天
        // 对于节气计算,应满足t在t1到t1+360天之间,对于Y年第n个节气(n=0是春分),t1可取值Y*365.2422+n*15.2
        // 对于朔望计算,应满足t在t1到t1+25天之间,在此范围之外,求右边的根
        var $t2 = $t1;
        var $t = 0;
        var $lx, $v1, $v2, $t1, $t2;

        if ($lx == 0) {
            $t2 += 360; // 在t1到t2范围内求解(范气360天范围),结果置于t
        } else {
            $t2 += 25;
        }

        $jiao *= Math.PI / 180; // 待搜索目标角
        // 利用截弦法计算


        $v1 = this.jiaoCai($lx, $t1, $jiao); // v1,v2为t1,t2时对应的黄经
        $v2 = this.jiaoCai($lx, $t2, $jiao);


        if ($v1 < $v2) {
            $v2 -= 2 * Math.PI; // 减2pi作用是将周期性角度转为连续角度
        }
        var $i;
        var $k = 1;
        // k是截弦的斜率
        for ($i = 0; $i < 10; $i++) { // 快速截弦求根,通常截弦三四次就已达所需精度
//            System.out.println("i = " + i);
            var $k2 = ($v2 - $v1) / ($t2 - $t1); // 算出斜率
            if (Math.abs($k2) > 1e-15) {
                $k = $k2; // 差商可能为零,应排除

            }
            var $t = $t1 - $v1 / $k;
            var $v = this.jiaoCai($lx, $t, $jiao);// 直线逼近法求根(直线方程的根)

            // echo "{$t}---{$lx}--{$jiao}--{$v}-----{$i}<br/>===============<br/>";


            if ($v > 1) {
                $v -= 2 * Math.PI; // 一次逼近后,v1就已接近0,如果很大,则应减1周
            }

            if (Math.abs($v) < 1e-8) {
                break; // 已达精度
            }

            $t1 = $t2;
            $v1 = $v2;
            $t2 = $t;
            $v2 = $v; // 下一次截弦


        }

        return $t;
    },

    jiaoCai: function ($lx, $t, $jiao) {


        // lx=1时计算t时刻日月角距与jiao的差, lx=0计算t时刻太阳黄经与jiao的差
        var $sun = this.earCal($t); // 计算太阳真位置(先算出日心坐标中地球的位置)


        $sun[0] += Math.PI;


        $sun[1] = -$sun[1]; // 转为地心坐标

        if ($lx == 0) {

            var $d = this.nutation($t);

            $sun[0] += $d['l']; // 补黄经章动

            $sun = this.addGxc($t, $sun); // 补周年光行差

            return this.rad2mrad($jiao - $sun[0]);
        }
        var $moon = this.moonCal($t); // 日月角差与章动无关

        return this.rad2mrad($jiao - ($moon[0] - $sun[0]));
    },


    // 传入儒略日(J2000起算),计算UTC与原子时的差(单位:日)
    deltatT2: function ($jd) {
        return this.deltatT($jd / 365.2425 + 2000) / 86400.0;
    },


    setFromJD: function ($jd, $UTC = false) {

        if ($UTC) {

            $jd -= this.deltatT2($jd - this.J2000);
            //exit;

        }

        $jd += 0.5;

        // 取得日数的整数部份A及小数部分F
        var $A = Math.floor($jd);
        var $F = $jd - $A;
        var $D, $Y, $D, $M, $h, $m, $s;


        if ($A > 2299161) {
            $D = Math.floor(($A - 1867216.25) / 36524.25);
            $A += 1 + $D - Math.floor($D / 4);
        }

        $A += 1524; // 向前移4年零2个月

        $Y = Math.floor(($A - 122.1) / 365.2500001);// 年
        $D = $A - Math.floor(365.2500001 * $Y); // 去除整年日数后余下日数
        $M = Math.floor($D / 30.6001); // 月数
        $D = $D - Math.floor($M * 30.6001);// 去除整月日数后余下日数
        $Y -= 4716;
        $M--;
        if ($M > 12) {
            $M -= 12;
        }

        if ($M <= 2) {
            $Y++;
        }

        // 日的小数转为时分秒
        $F *= 24;
        $h = Math.floor($F);
        $F -= $h;
        $F *= 60;


        $m = Math.floor($F);


        $F -= $m;
        $F *= 60;
        $s = Math.floor($F);
        // console.log("setFromJD---", $Y, $M, $D, $h, $m, $s)
        return [$Y, $M, $D, $h, $m, $s];
        //echo $Y." ".$M." ".$D." ".$h." ".$m;
    },


    // 返回月球位置,返回地心Date黄道坐标
    moonCal: function ($jd) {
        var $t1, $t2, $t3, $t4;
        this.MnnT = $jd / 36525;
        $t1 = this.MnnT;
        $t2 = $t1 * $t1;
        $t3 = $t2 * $t1;
        $t4 = $t3 * $t1;
        var $llr = [];

        $llr[0] = (this.Mnn(this.M10) + this.Mnn(this.M11) * $t1 + this.Mnn(this.M12) * $t2) / this.rad;
        $llr[1] = (this.Mnn(this.M20) + this.Mnn(this.M21) * $t1) / this.rad;
        $llr[2] = (this.Mnn(this.M30) + this.Mnn(this.M31) * $t1) * 0.999999949827;
        $llr[0] = $llr[0] + this.M1n[0] + this.M1n[1] * $t1 + this.M1n[2] * $t2 + this.M1n[3] * $t3 + this.M1n[4] * $t4;
        $llr[0] = this.rad2mrad($llr[0]); // 地心Date黄道原点坐标(不含岁差)
        $llr = this.addPrece($jd, $llr); // 补岁差
        return $llr;
    },

    // 补岁差
    addPrece: function ($jd, $zb) {
        var $t1, $v, $t, $i;
        $t = 1;
        $v = 0;
        $t1 = $jd / 365250;
        for ($i = 1; $i < 8; $i++) {
            $t *= $t1;
            $v += this.preceB[$i] * $t;
        }
        $zb[0] = this.rad2mrad($zb[0] + ($v + 2.9965 * $t1) / this.rad);
        return $zb;
    },

    // 计算M10,M11,M20等,计算前先设置MnnT时间
    Mnn: function ($F) {
        var $v, $t1, $t2, $t3, $t4, $num, $i;
        $v = 0;
        $t1 = this.MnnT;
        $t2 = $t1 * $t1;
        $t3 = $t2 * $t1;
        $t4 = $t3 * $t1;
        $num = $F.length;

        for ($i = 0; $i < $num; $i += 6) {
            $v += $F[$i] * Math.sin($F[$i + 1] + $t1 * $F[$i + 2] + $t2 * $F[$i + 3] + $t3 * $F[$i + 4] + $t4 * $F[$i + 5]);
        }
        return $v;
    },

    // 返回地球位置,日心Date黄道分点坐标
    earCal: function ($jd) {
        var $t1, $t2, $t2, $t4, $t5, $t3;
        this.EnnT = $jd / 365250;
        var $llr = [];
        $t1 = this.EnnT;
        $t2 = $t1 * $t1;
        $t3 = $t2 * $t1;
        $t4 = $t3 * $t1;
        $t5 = $t4 * $t1;

        $llr[0] = this.Enn(this.E10)
            + this.Enn(this.E11) * $t1 + this.Enn(this.E12) * $t2
            + this.Enn(this.E13) * $t3 + this.Enn(this.E14) * $t4
            + this.Enn(this.E15) * $t5;

        $llr[1] = this.Enn(this.E20) + this.Enn(this.E21) * $t1;
        $llr[2] = this.Enn(this.E30) + this.Enn(this.E31) * $t1 + this.Enn(this.E32) * $t2 + this.Enn(this.E33) * $t3;
        $llr[0] = this.rad2mrad($llr[0]);
        return $llr;
    },

    Enn: function ($F) {
        var $v, $num, $i;
        $v = 0;
        $num = $F.length;
        for ($i = 0; $i < $num; $i += 3) {
            $v += $F[$i] * Math.cos($F[$i + 1] + this.EnnT * $F[$i + 2]);
        }
        return $v;
    },

    // 计算黄经章动及交角章动
    nutation: function nutation($t) {
        var $d = [], $c;
        $d['l'] = 0;
        $d['o'] = 0;
        $t /= 36525;
        var $t1 = $t;
        var $t2 = $t1 * $t1;
        var $t3 = $t2 * $t1;
        var $t4 = $t3 * $t1;// t5=t4*t1;
        var $nutB = this.nutB;
        var $length = $nutB.length;
        var $i;
        for ($i = 0; $i < $length; $i += 9) {
            $c = $nutB[$i] + $nutB[$i + 1] * $t1 + $nutB[$i + 2] * $t2 + $nutB[$i + 3] * $t3 + $nutB[$i + 4] * $t4;
            $d['l'] += ($nutB[$i + 5] + $nutB[$i + 6] * $t / 10) * Math.sin($c); // 黄经章动
            $d['o'] += ($nutB[$i + 7] + $nutB[$i + 8] * $t / 10) * Math.cos($c); // 交角章动
        }
        $d['l'] /= this.rad * 10000; // 黄经章动
        $d['o'] /= this.rad * 10000; // 交角章动
        return $d;
    },

    // 恒星周年光行差计算(黄道坐标中)
    addGxc: function ($t, $zb) {

        // echo $zb[0]."------{$zb[1]}------{$zb[2]}-----<br/>";
        var $t1, $t2, $t3, $t4, $GXC_l, $GXC_p, $GXC_e, $GXC_k, $L, $p, $e;
        $t1 = $t / 36525;
        $t2 = $t1 * $t1;
        $t3 = $t2 * $t1;

        $t4 = $t3 * $t1;
        $GXC_l = this.GXC_l;
        $GXC_p = this.GXC_p;
        $GXC_e = this.GXC_e;
        $GXC_k = this.GXC_k;

        $L = $GXC_l[0] + $GXC_l[1] * $t1 + $GXC_l[2] * $t2 + $GXC_l[3] * $t3 + $GXC_l[4] * $t4;
        $p = $GXC_p[0] + $GXC_p[1] * $t1 + $GXC_p[2] * $t2;
        $e = $GXC_e[0] + $GXC_e[1] * $t1 + $GXC_e[2] * $t2;

        // echo $GXC_l[3]."-zai--".$GXC_l[4] ."---{$t3}--{$t4}--<br/>";

        //echo "------{$L}---{$p}---{$e}---+++++--<br/>";

        var $dL = $L - $zb[0];
        var $dP = $p - $zb[0];
        $zb[0] -= $GXC_k * (Math.cos($dL) - $e * Math.cos($dP)) / Math.cos($zb[1]);
        $zb[1] -= $GXC_k * Math.sin($zb[1]) * (Math.sin($dL) - $e * Math.sin($dP));
        $zb[0] = this.rad2mrad($zb[0]);

        return $zb;
        // echo $zb[0]."------{$zb[1]}------{$zb[2]}---here--<br/>";
    },

    // 对超过0-2PI的角度转为0-2PI
    rad2mrad: function ($v) {
        //$v = fmod($v, 2 * Math.PI);
        $v = $v % (2 * Math.PI);
        if ($v < 0)
            return $v + 2 * Math.PI;

        return $v;
    },


    // 计算世界时与原子时之差,传入年
    deltatT: function ($y) {
        var $i = 0;
        var $t1, $t2, $t3;
        for ($i = 0; $i < 100; $i += 5) {
            if ($y < this.dts[$i + 5] || $i == 95)
                break;
        }

        $t1 = ($y - this.dts[$i]) / (this.dts[$i + 5] - this.dts[$i]) * 10;
        $t2 = $t1 * $t1;
        $t3 = $t2 * $t1;
        return this.dts[$i + 1] + this.dts[$i + 2] * $t1 + this.dts[$i + 3] * $t2 + this.dts[$i + 4] * $t3;
    }

}

export {
    PAIPAN
}